// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Firefox (uncomment to work in Firefox, although other properties will not work!)  */
/** {
  scrollbar-width: thin;
  scrollbar-color: #CCCCCC #FFFFFF;
}*/
/*******************************************/
/*                                         */
/* S'applique à tous les tailles d'écrans  */
/*                                         */
/*******************************************/
/* Chrome, Edge and Safari */
*::-webkit-scrollbar {
  height: 5px;
  width: 5px;
}

*::-webkit-scrollbar-track {
  border-radius: 28px;
  background-color: transparent;
  border: 1px solid #EDF2F5;
}

*::-webkit-scrollbar-thumb {
  border-radius: 20px;
  background-color: #EDF2F5;
}

*::-webkit-scrollbar-thumb:hover {
  background-color: #007566;
  border: 1px solid #007566;
}

*::-webkit-scrollbar-thumb:active {
  background-color: #007566;
  border: 1px solid #007566;
}

@supports (-webkit-touch-callout: none) {
  html, body {
    height: -webkit-fill-available;
  }
}
.background-wrapper {
  position: relative;
  min-height: 100vh;
  height: 100%;
  height: -webkit-fill-available;
  /* This makes sure the wrapper takes up the full height of the viewport */
  background-image: none;
}
.background-wrapper:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  display: none;
  z-index: 0;
}

.sherpa-container {
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  width: 950px;
  margin: 0 auto;
  height: 100vh;
  position: relative;
  z-index: 1000;
}
.sherpa-container.mobile {
  height: 100svh;
}

#avertissement {
  flex: 1 1 auto;
  position: absolute;
  bottom: 0;
}

.page {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;
  padding-bottom: 24px;
}
.page__txt {
  margin: auto;
}

.page-chatwindowvisible {
  padding-bottom: 0;
  margin-bottom: 0;
}

.txt {
  color: #fff;
  font-family: "Arial Black", sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  letter-spacing: 0px;
  display: flex;
  margin: 0 auto;
  padding: 0;
  margin: 0;
}
.txt.chat-window-visible {
  font-family: "Arial Black", sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  letter-spacing: 0px;
}
.txt__character {
  transform: translateX(0);
}
.txt.terms {
  font-size: 50px !important;
}

.entete {
  padding: 50px 9px 9px 9px;
}

.entete-chat-window-visible {
  padding: 9px 9px 0px 9px;
  margin: 0 auto !important;
}

#sherpa-entete {
  margin: 12px auto;
  margin-bottom: 3px;
}
#sherpa-entete .sous-entete h2 {
  color: #fff;
  font-family: Arial, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  font-weight: 700;
}

#sherpa-chat {
  width: 100%;
  margin: 0 auto;
}
#sherpa-chat .report-button-container {
  margin: 12px 12px;
  padding: 12px 12px 40px;
  margin-top: 3px;
}
#sherpa-chat .chat-window {
  margin: 12px auto;
  margin-top: 3px;
  width: 100%;
}

.avertissement-question {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  position: relative;
  top: 49px;
  margin-top: -36px;
}
.avertissement-question.duo-mode {
  top: 60px;
}
.avertissement-question p {
  color: #111111;
  padding-bottom: 0;
  margin-bottom: 0;
}
.avertissement-question p:last-of-type {
  position: relative;
  top: 1px;
}
.avertissement-question p:last-of-type.duo-mode {
  height: 36px;
}

.question-sub-header {
  padding: 30px 0 0 0;
}
.question-sub-header p {
  color: #fff;
  font-family: Arial, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding-bottom: 0;
  margin-bottom: 0;
}

.modal-body {
  border-radius: 0 0 5px 5px;
}

.chat-messages {
  background-color: #fff;
  border-radius: 26px;
  padding: 24px 24px 12px;
  margin: 12px auto;
  width: 100%;
}
.chat-messages .chat-message-body {
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 20px;
  max-height: 200px;
}
.chat-messages .chat-messages-bottom {
  overflow-y: hidden;
  overflow-x: hidden;
}
.chat-messages .chat-messages-bottom .left-buttons .iconButton {
  margin: 5px 6px;
  padding: 0 3px;
  margin-left: 0;
  padding-left: 0;
}
.chat-messages .chat-messages-bottom .left-buttons .iconButton:first-of-type {
  margin-left: 0;
  padding-left: 0;
}
.chat-messages .chat-messages-bottom .right-buttons span {
  padding: 0 9px;
  margin: 0 9px;
}
.chat-messages .chat-messages-bottom .right-buttons .iconButton {
  margin: 5px 5px;
}
.chat-messages .chat-messages-bottom .right-buttons .iconButton:first-of-type {
  margin-left: 6px;
  margin-right: 0;
}
.chat-messages .chat-messages-bottom .right-buttons .iconButton:last-of-type {
  margin-right: 0;
  margin-left: 0;
}

.chat-input {
  padding-top: 10px;
  width: 100%;
}
.chat-input select {
  margin-right: 10px;
}
.chat-input .input-wrapper {
  position: relative;
  width: 100%;
  display: inline-block;
}
.chat-input input {
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  line-height: 18px;
  padding: 18px 60px 18px 24px;
  border: none;
  border-radius: 28px;
  width: 100%;
  box-shadow: 0px 4px 13.1px 0px rgba(0, 0, 0, 0.25);
}
.chat-input .chat-buttons {
  position: absolute;
  right: 7px;
  top: 5px;
  height: 44px;
  width: 44px;
  border-radius: 50%;
  text-align: center;
  border: none;
  background-color: #007566;
  transition: all 0.3s ease;
}
.chat-input .chat-buttons:hover {
  background-color: #007566;
}
.chat-input .chat-buttons .arrow-forward {
  padding: 10px;
}

.iconButton {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
}
.iconButton .icon.refresh {
  transition: transform 0.6s ease;
}
.iconButton .icon.refresh:hover {
  transform: rotate(180deg);
}
.iconButton .icon.thumbs_up {
  transition: transform 0.4s ease;
}
.iconButton .icon.thumbs_up:hover {
  transform: rotate(-30deg);
}
.iconButton .icon.thumbs_down {
  transition: transform 0.4s ease;
}
.iconButton .icon.thumbs_down:hover {
  transform: rotate(-30deg);
}
.iconButton.thumbs-up-button, .iconButton.thumbs-down-button {
  border-radius: 10px;
  width: 30px;
  height: 30px;
  background-color: transparent;
  transition: background-color 0.8s ease;
}
.iconButton.copy-to-clipboard {
  padding-left: 3px !important;
  width: 30px;
  height: 30px;
  background-color: transparent;
  transition: transform 0.4s ease;
}
.iconButton.copy-to-clipboard:hover {
  transform: scale(1.1);
}
.iconButton:disabled {
  background: none;
}

.loading-indicator {
  padding: 10px 35px 20px 0;
  font-family: "Arial";
}

.chat-question-container {
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0 0 18px 0;
  background-color: #fff;
}

.chat.question .text {
  color: #111111;
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.chat.answer {
  padding: 0 25px 0 0;
  margin-bottom: 0;
  max-height: 274px;
  transition: max-height 0.3s ease;
}
.chat.answer p {
  line-height: 23px;
}
.chat.answer.reduced {
  max-height: 50px;
}
.chat.answer .text {
  padding-bottom: 20px;
}
.chat.error-message {
  padding: 20px 35px 20px 20px;
  margin-bottom: 0;
  height: 100%;
  color: red;
}

.btn-report {
  padding: 8px 60px;
  border: 1px solid #fff;
  width: 215px;
}
.btn-report.personalite {
  border-radius: 2px 0px 0px 2px;
}
.btn-report.duo {
  border-radius: 0px 2px 2px 0px;
}
.btn-report.personalite:hover, .btn-report.talents:hover, .btn-report.iac:hover, .btn-report.pcr:hover, .btn-report.duo:hover {
  background-color: #E1FFF0 !important;
  color: #111111;
  box-shadow: 0px 4px 13.1px 0px rgba(0, 0, 0, 0.25);
}
.btn-report.personalite.selected, .btn-report.talents.selected, .btn-report.iac.selected, .btn-report.pcr.selected, .btn-report.duo.selected {
  background-color: #fff !important;
  border-color: #fff !important;
  color: #111111 !important;
  box-shadow: 0px 4px 13.1px 0px rgba(0, 0, 0, 0.25);
}
.btn-report.personalite:focus, .btn-report.talents:focus, .btn-report.iac:focus, .btn-report.pcr:focus, .btn-report.duo:focus {
  outline: none;
  outline-offset: 0;
}
.btn-report.personalite:not(.selected), .btn-report.talents:not(.selected), .btn-report.iac:not(.selected), .btn-report.pcr:not(.selected), .btn-report.duo:not(.selected) {
  background-color: transparent !important;
  color: #fff !important;
  border: 1px solid #fff !important;
}
.btn-report.personalite:not(.selected):hover, .btn-report.talents:not(.selected):hover, .btn-report.iac:not(.selected):hover, .btn-report.pcr:not(.selected):hover, .btn-report.duo:not(.selected):hover {
  background-color: #E1FFF0 !important;
  color: #111111 !important;
}
.btn-report.personalite:disabled, .btn-report.talents:disabled, .btn-report.iac:disabled, .btn-report.pcr:disabled, .btn-report.duo:disabled {
  background-color: transparent !important;
  color: #EDF2F5 !important;
  cursor: not-allowed;
}
.btn-report.chat-buttons {
  flex: 1 1 auto;
  text-align: center;
}
.btn-report.chat-buttons.btn-next-question {
  margin-left: auto;
}
.btn-report.chat-buttons:last-child {
  max-width: max-content;
  flex: 1 0 0%;
}
.btn-report.chat-buttons:not(:first-child):not(:last-child) {
  margin: 0 5px;
}

.personality-button-container {
  position: relative;
}
.personality-button-container .radio-button {
  position: absolute;
  top: 51px;
  left: 0;
}
.personality-button-container .radio-button input[type=radio] {
  height: 20px;
  width: 20px;
  margin-top: 0;
  cursor: pointer;
  accent-color: #007566;
}
.personality-button-container .radio-button label {
  position: relative;
  padding-left: 10px;
  color: white;
  padding-right: 10px;
}
.personality-button-container .radio-button label:first-of-type {
  padding-right: 24px;
}

.icon-disabled-radio {
  width: 20px;
  height: 20px;
}

.x-close {
  margin-left: 10px;
}

.hr-jil {
  width: 114px;
  background-color: #EDF2F5;
  opacity: 30%;
  height: 1px;
  border: none;
  margin: 58px 0 16px;
}

.people-dropdown {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.duo-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.duo-content {
  width: 598px;
  position: fixed;
  top: 20%; /* Adjust this value as needed */
  left: 50%;
  transform: translateX(-50%);
  background-color: white;
  padding: 0 12px 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1001;
  border-radius: 8px;
  transition: height 1s ease;
}
.duo-content.expanded {
  height: 400px;
}
.duo-content .button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  gap: 12px;
}
.duo-content .button-container button {
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #fff;
  padding: 6px 12px;
  width: 109px;
  border-radius: 2px;
}
.duo-content .button-container button.add {
  background-color: #007566;
}
.duo-content .button-container button.add:disabled {
  background-color: #EDF2F5;
}
.duo-content .button-container button.cancel {
  background-color: #111111;
}
.duo-content .button-container button.reset {
  background-color: #007566;
}

.search-input {
  width: 100%;
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.input-container {
  position: relative;
}
.input-container input {
  padding: 16px 16px 16px 12px;
  margin: 0;
  font-family: Arial, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #111111;
  border: none;
  border-bottom: 1px solid #EDF2F5;
}
.input-container input::placeholder {
  color: #111111;
}

.search-input {
  width: 100%;
  padding-right: 30px; /* Adjust based on the size of the clear button */
}

.clear-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
}

.people-viewport {
  min-height: 50px;
  max-height: 200px;
  width: 100%;
  border: none;
  border-radius: 4px;
  overflow: auto;
  margin-top: 15px;
  margin-left: 6px;
}
.people-viewport .cdk-virtual-scroll-spacer {
  height: 100% !important;
}
.people-viewport .people-name-container {
  gap: 12px;
}
.people-viewport .people-name-container .seperator {
  margin: 0 6px;
}
.people-viewport .people-name-container .person-email {
  font-family: Arial, sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #111111;
}
.people-viewport .no-results {
  font-family: Arial, sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #111111;
  font-style: italic;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.people-item {
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #111111;
  padding: 5px 10px;
  border-bottom: 1px solid #F7F5F2;
  margin-right: 6px;
  cursor: pointer;
}
.people-item:hover {
  background-color: #F7F5F2;
}
.people-item:last-of-type {
  border-bottom: none;
}
.people-item .creation-date {
  font-family: Arial, sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  color: #111111;
}
.people-item strong {
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}

.duo-name-container {
  gap: 10px;
  width: 100%;
  margin-top: -35px;
  padding-bottom: 5px;
}
.duo-name-container.duo-mode-mobile {
  position: relative;
  top: 10px;
}
.duo-name-container .duo-name-individual {
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #fff;
}
.duo-name-container .duo-name-individual.pill {
  border-radius: 26px;
  background-color: #111111;
  padding: 3px 5px 3px 11px;
}
.duo-name-container .duo-name-individual.pill button.remove-button {
  background-color: transparent;
  cursor: pointer;
}
.duo-name-container .duo-name-individual.pill button.remove-button .remove-person {
  width: 24px;
  height: 24px;
}

#thematique {
  margin: 12px auto;
  padding: 9px 0px 12px;
}
#thematique p {
  color: #fff;
  font-family: Arial, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 0 0 18px;
}
#thematique p.section-collapsed {
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
#thematique p.section-collapsed:first-of-type {
  padding-bottom: 0;
}
#thematique .question-category-container {
  width: 100%;
  padding-bottom: 18px;
}
#thematique .question-category-container .question-category {
  position: relative;
  margin: 6px 6px;
}
#thematique .question-category-container .question-category button {
  color: #fff;
  font-family: Arial, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 12px 24px;
  background-color: #007566;
  border-radius: 100px;
  border: 1px solid #007566;
  transition: all 0.3s ease;
}
#thematique .question-category-container .question-category button:hover {
  color: #007566;
  background-color: #fff;
}
#thematique .question-category-container .question-category .back-button {
  position: absolute;
  left: -130px;
  bottom: 0;
  background-color: transparent;
  border: none;
}
#thematique .question-category-container .question-category .back-button:hover {
  color: none;
  background-color: transparent;
}
#thematique .question-category-container .question-category .back-button span {
  color: #fff;
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  padding-left: 10px;
}
#thematique .question-puck {
  color: #111111;
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 3px auto;
  text-align: center;
  padding: 10px 18px;
  background-color: #fff;
  border-radius: 36px;
  border: 1px solid #EDF2F5;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
#thematique .question-puck:hover {
  color: #111111;
  background-color: #E1FFF0;
}
#thematique .question-puck:last-of-type {
  margin-bottom: 20px;
}
#thematique .arrow-show-hide {
  position: relative;
  height: 36px;
  width: 36px;
  border-radius: 50%;
  text-align: center;
  border: 1px solid #fff;
  background-color: transparent;
  transition: transform 0.4s ease;
}
#thematique .arrow-show-hide:hover {
  transform: translateY(5px);
}
#thematique .arrow-show-hide .arrow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.reason-outer-box {
  width: 100%;
}
.reason-outer-box .reasons-container {
  width: 700px;
  flex-wrap: wrap;
}
.reason-outer-box .reason-button {
  color: #111111;
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  padding: 3px 12px;
  background-color: #F7F5F2;
  border-radius: 21px;
  margin: 5px;
  transition: all 0.3s ease;
}
.reason-outer-box .reason-button:hover, .reason-outer-box .reason-button.selected-reason {
  color: #fff;
  background-color: #111111;
}

.gradient-background {
  position: relative;
  background: linear-gradient(0deg, #fff 19.26%, rgba(255, 255, 255, 0) 100%);
  top: -53px;
  height: 50px;
  margin-bottom: -60px;
  width: 98%;
}

.help-button-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.help-button {
  position: relative;
  background-color: transparent;
  border: 1px solid #EDF2F5;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}
.help-button .question-mark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.help-button:hover {
  background: #E1FFF0;
}

.help-menu {
  position: absolute;
  width: 148px;
  bottom: 50px;
  right: 0;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.help-menu button {
  color: #111111;
  display: block;
  width: 100%;
  font-family: Arial, sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  padding: 6px;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.3s ease;
}
.help-menu button:first-of-type {
  border-bottom: 1px solid #F7F5F2;
}

.help-menu button:hover {
  background-color: #E1FFF0;
}

#sherpa-notices {
  padding-top: 111px;
}
#sherpa-notices h2 {
  color: #fff;
  font-family: Arial, sans-serif;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-align: center;
}
#sherpa-notices h2.mobile {
  width: 350px;
}

.icon-jil {
  padding-bottom: 24px;
}

.faq-header,
.notice-header {
  padding-bottom: 30px;
}

.faq-body,
.notices-body {
  background-color: #fff;
  border-radius: 26px;
  position: relative;
}

.notices-body {
  padding: 24px 24px 0px 24px;
}

.faq-body {
  padding: 24px 24px 0px 24px;
}

.close-button {
  background-color: transparent;
  position: absolute;
  right: 24px;
  top: 24px;
}
.close-button img {
  width: 10px;
}

.terms-and-conditions .faq-wrapper,
.terms-and-conditions .terms-wrapper {
  margin: 0 auto 30px;
}
.terms-and-conditions .faq-wrapper h1,
.terms-and-conditions .terms-wrapper h1 {
  color: #111111;
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  padding-bottom: 18px;
}
.terms-and-conditions .faq-wrapper h3,
.terms-and-conditions .terms-wrapper h3 {
  color: #111111;
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.terms-and-conditions .faq-wrapper h4,
.terms-and-conditions .terms-wrapper h4 {
  color: #111111;
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.terms-and-conditions .faq-wrapper p,
.terms-and-conditions .terms-wrapper p {
  color: #111111;
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.terms-and-conditions .faq-wrapper .scrollable-section,
.terms-and-conditions .terms-wrapper .scrollable-section {
  max-height: 350px;
  overflow-y: auto;
  padding-right: 18px;
}
.terms-and-conditions .faq-wrapper .scrollable-section.terms-smal-viewport,
.terms-and-conditions .terms-wrapper .scrollable-section.terms-smal-viewport {
  max-height: 410px;
}
.terms-and-conditions .faq-wrapper .faq-scrollable-section,
.terms-and-conditions .terms-wrapper .faq-scrollable-section {
  max-height: 450px;
  overflow-y: auto;
  padding-right: 18px;
}
.terms-and-conditions .terms-footer {
  padding-bottom: 30px;
}
.terms-and-conditions .acceptation-checkbox-wrapper {
  cursor: pointer;
  margin-bottom: 18px;
}
.terms-and-conditions .acceptation-checkbox-wrapper input {
  margin-right: 12px;
}
.terms-and-conditions .checkbox-container p {
  color: #111111;
  font-family: Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  padding: 0;
  margin: 0;
}
.terms-and-conditions .btn-continue {
  color: #fff;
  font-family: "Arial";
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  padding: 6px 12px;
  border-radius: 2px;
  background-color: #007566;
  transition: background-color 0.3s ease;
}
.terms-and-conditions .btn-continue:hover {
  background-color: #007566;
}
.terms-and-conditions .btn-continue:disabled {
  color: #111111;
  background-color: #EDF2F5;
  cursor: not-allowed;
}

#faq-section {
  position: relative;
  top: 30%;
  transform: translate(0%, -30%);
  margin: 0 auto;
}

.faq-title {
  color: #fff;
  font-family: "Arial Black";
  font-size: 65px;
  font-style: normal;
  font-weight: 700;
  line-height: 75px;
  padding: 0;
  margin: 0;
}

.top-close-button-container {
  display: none;
}

#avertissement {
  padding-bottom: 24px !important;
}

/*******************************************/
/*                                         */
/* S'applique au écrans avec une hauteur   */
/* de 975px et moins                       */
/*                                         */
/*******************************************/
@media (max-height: 925px) {
  .sherpa-container {
    justify-content: flex-start !important;
    position: relative;
    width: 100%;
    padding: 40px 80px 80px;
  }
  .container-chat-window-visible {
    padding: 10px 80px;
  }
  .txt.chat-window-visible {
    font-family: "Arial Black", sans-serif;
    font-size: 40px;
    font-style: normal;
    font-weight: 900;
    line-height: normal;
    letter-spacing: 0px;
  }
  #sherpa-entete {
    margin: 0 auto;
  }
  .entete {
    padding: 0 9px 16px 9px;
  }
  #sherpa-chat .chat-window {
    margin: 0 auto;
    width: 100%;
  }
  .avertissement-question {
    font-family: Arial, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    font-size: 10px !important;
    top: 44px;
    margin-top: -36px;
    margin-left: -13px;
    margin-right: -13px;
  }
  .avertissement-question p {
    color: #111111;
    padding-bottom: 0;
    margin-bottom: 0;
  }
  .avertissement-question p:last-of-type {
    position: relative;
    top: 0px;
  }
  #sherpa-notices {
    padding-top: 0;
  }
  #avertissement {
    flex: 1 1 auto;
    position: absolute;
    bottom: 0;
  }
  #avertissement.mobile {
    padding: 20px 15px 15px !important;
    bottom: 75px;
  }
  .entete.entete-chat-window-visible {
    padding: 0;
    margin: 0;
  }
  .personality-button-container .radio-button {
    position: absolute;
    top: 60px;
    left: 0;
  }
  #sherpa-chat .report-button-container {
    margin: 0px 12px 0;
    padding: 0px 12px 53px;
  }
  .question-sub-header {
    padding: 8px 0 18px 0;
  }
  .question-sub-header p {
    font-family: "Arial";
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    padding-bottom: 0;
  }
  .question-category-container {
    padding-bottom: 20px;
    width: 680px !important;
  }
  .chat-question-container {
    padding: 0 0 10px 0;
  }
  .chat.answer {
    max-height: 200px;
  }
  .chat.answer.reduced {
    max-height: 10px;
  }
  .chat-messages {
    margin: 12px auto 50px;
  }
  #thematique {
    width: 100%;
    margin: 12px auto;
    padding: 52px 0px 12px;
  }
  #thematique.avertissement-none {
    padding-top: 10px !important;
  }
  #thematique .question-category-container .question-category button {
    font-family: Arial, sans-serif;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    padding: 6px 12px;
  }
  #thematique .thematique-text-box {
    padding: 0 0 9px;
    margin: 0 0 9px;
  }
  #thematique .small-thematique-text-box {
    padding: 0 0 6px;
    margin: 0 0 1.5px;
  }
  #thematique .question-puck {
    font-family: Arial, sans-serif;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    padding: 6px 12px;
  }
  #thematique p {
    font-family: Arial, sans-serif;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    padding: 0 0 0;
  }
  .chat-input .input-wrapper {
    width: 100%;
  }
  .chat-input input {
    margin-right: 0;
    width: 100%;
  }
  .gradient-background {
    position: relative;
    background: linear-gradient(0deg, #fff 19.26%, rgba(255, 255, 255, 0) 100%);
    top: -52px;
    height: 40px;
    width: 98%;
  }
  .chat-messages .chat-message-body {
    max-height: 300px;
  }
  .chat-messages .chat-messages-bottom {
    overflow-y: hidden;
    overflow-x: hidden;
    padding-top: 0;
    margin-top: 0;
  }
  #thematique .question-category-container .question-category {
    margin: 4.5px 4.5px;
  }
}
/*******************************************/
/*                                         */
/* S'applique au écrans avec une Largeur   */
/* de 1500px et moins                      */
/*                                         */
/*******************************************/
@media (max-width: 1500px) {
  .btn-report {
    width: 195px;
  }
  .rightWrapper {
    margin-right: unset;
  }
  .sherpa-container {
    margin: 0 auto;
  }
  .sherpa-chat {
    padding-left: 30px;
    padding-right: 30px;
  }
  .chat-messages {
    background-color: #fff;
    border-radius: 26px;
    padding: 24px 24px 12px;
    margin: 12px auto 50px;
  }
  .chat-input {
    width: 100%;
    padding: 10px 20px;
  }
  .chat-input .input-wrapper {
    width: 100%;
  }
  .chat-input input {
    margin-right: 0;
  }
}
/*******************************************/
/*                                         */
/* S'applique au écrans avec une Largeur   */
/* de 1440px et moins                      */
/*                                         */
/*******************************************/
@media (max-width: 1440px) {
  .rightWrapper {
    margin-right: 0 !important;
  }
  .sherpa-container {
    width: 100%;
    margin: 0 auto;
    margin-left: none;
  }
  #sherpa-chat {
    width: 100%;
    padding-left: 12px;
    padding-right: 12px;
    margin: 0 auto;
  }
  #thematique {
    padding-left: 30px;
    padding-right: 30px;
  }
  .chat-window {
    flex: 1 1 auto;
    width: 100%;
  }
  .chat-window .chat-input {
    padding: 10px 0px;
  }
  .chat-window .chat-input .input-wrapper {
    width: 100%;
    flex: 1 1 auto;
  }
  .chat-window .chat-input .input-wrapper input {
    width: 100%;
  }
}
/*******************************************/
/*                                         */
/* S'applique au écrans avec une Largeur   */
/* de 1235px et moins                      */
/*                                         */
/*******************************************/
@media (max-width: 1235px) {
  .sherpa-container {
    position: relative;
  }
  .top-mobile-div {
    position: absolute;
    top: 20px;
    right: 20px;
  }
  .top-controls {
    position: absolute;
    top: 20px;
    right: 20px;
  }
  .top-close-button-container {
    display: flex;
  }
  .top-close-button-container button.top-close-button {
    background-color: transparent;
  }
  .sherpa-outer-column {
    margin-left: 0;
  }
}
/*******************************************/
/*                                         */
/* S'applique au écrans avec une Largeur   */
/* comprise entre 374px et 820px           */
/*                                         */
/*******************************************/
/* New media query for mobile devices between 315px and 500px */
@media (min-width: 374px) and (max-width: 820px) {
  html, body {
    height: -webkit-fill-available;
  }
  .sherpa-outer-column {
    position: relative;
    z-index: 100000;
  }
  .top-mobile-div {
    position: unset;
    width: 100%;
    display: flex;
  }
  .top-controls {
    width: 100%;
    padding: 0 15px;
    position: unset;
  }
  .top-close-button {
    background: transparent;
  }
  .messages-bottom .left-buttons .iconButton {
    margin-left: 2px;
  }
  .icon.thumbs_up:hover {
    transform: rotate(0deg) !important;
  }
  .icon.thumbs_down:hover {
    transform: rotate(0deg) !important;
  }
  .menu-container {
    height: 41px;
    background-color: #E1FFF0;
    border-radius: 2px 2px 2px 2px;
  }
  .menu-container .hamburger-container {
    position: relative;
    background-color: #007566;
    padding: 10px 12px;
    border-radius: 2px 0 0 2px;
  }
  .menu-container .hamburger-container .top-menu {
    min-width: 215px;
    position: absolute;
    top: 50px;
    left: 0;
    border-radius: 2px;
    background-color: #fff;
    box-shadow: 0px 4px 13.1px 0px rgba(0, 0, 0, 0.25);
    z-index: 1000;
  }
  .menu-container .hamburger-container .top-menu .inner-menu-label {
    color: #111111;
    font-family: "Arial";
    font-size: 9px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    text-transform: uppercase;
    padding: 12px;
    width: 100%;
    border-bottom: 1px solid #F7F5F2;
  }
  .menu-container .hamburger-container .top-menu .inner-menu-button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    white-space: nowrap;
    background-color: #fff;
    color: #111111;
    font-family: Arial, sans-serif;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    padding: 12px 18px 6px;
  }
  .menu-container .hamburger-container .top-menu .inner-menu-button:last-of-type {
    padding-bottom: 18px;
  }
  .menu-container .label-container {
    width: 100%;
  }
  .menu-container .label-container .menu-label {
    padding: 7px 17px;
    color: #111111;
    text-align: center;
    font-family: Arial;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }
  .line {
    position: relative;
    z-index: 1000;
    width: 17px;
    height: 3px;
    background-color: #EDF2F5;
    display: block;
    margin: 3px auto;
    transition: transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.5s cubic-bezier(0.25, 0.8, 0.25, 1), width 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  .hamburger.is-active {
    transform: rotate(90deg);
  }
  .hamburger.is-active .line:nth-child(2) {
    opacity: 0;
    transition: opacity 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  .hamburger .line:nth-child(2) {
    transition-delay: 0.2s;
  }
  .hamburger.is-active .line:nth-child(1),
  .hamburger.is-active .line:nth-child(3) {
    width: 17px;
    transform-origin: right;
    transition: transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1), width 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
  }
  .hamburger.is-active .line:nth-child(1) {
    transform: translateY(5px) rotate(-45deg);
  }
  .hamburger.is-active .line:nth-child(3) {
    transform: translateY(-5px) rotate(45deg);
  }
  .rightWrapper {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .activate-sherpa-container[_ngcontent-ng-c3832421973] {
    width: 90% !important;
    margin: 15px auto !important;
  }
  .sherpa-outer-column {
    min-width: unset !important;
    margin-left: 0 !important;
    min-height: 100vh;
    height: 100%;
    height: -webkit-fill-available;
    background: linear-gradient(135deg, #007566 0%, #EDF2F5 100%);
  }
  .background-wrapper {
    min-height: unset;
    height: 100dvh;
    background-image: none;
  }
  .background-wrapper:before {
    display: none;
  }
  .sherpa-container {
    justify-content: space-between !important;
    width: 100%;
    margin: 0 auto;
    left: 0 !important;
    padding: 20px 0 135px !important;
    position: relative;
    height: 100svh;
  }
  .sherpa-container.first-question-asked {
    padding: 20px 0 75px !important;
  }
  .container-terms-faq {
    justify-content: start !important;
  }
  #faq-section {
    top: 0;
    transform: translate(0, 0);
  }
  #faq-section .faq-body {
    width: 95%;
    margin: 0 auto;
  }
  #sherpa-notices {
    padding-top: 0;
    margin-top: 0;
    width: 95%;
  }
  #sherpa-entete .sous-entete h2 {
    text-align: center;
    width: 280px;
  }
  .entete {
    padding: 20px 10px;
  }
  .entete.entete-chat-window-visible {
    padding: 5px 12px 9px;
    margin: 0 auto !important;
  }
  .mobile-chat-window {
    width: 100%;
    padding: 0 12px;
    display: flex;
  }
  .chat-messages {
    flex: 1 1 auto;
    overflow-y: auto;
    margin: 12px auto;
  }
  .chat-messages.duo-mode {
    margin: 0 auto;
    margin-bottom: 40px;
  }
  .chat-messages .chat-message-body {
    max-height: unset;
  }
  .chat-answer-container {
    display: flex;
  }
  .chat.answer {
    flex: 1 1 auto;
    overflow-y: auto;
    max-height: 190px;
  }
  .gradient-background {
    top: -60px;
    width: 97%;
  }
  .loading-indicator {
    padding-bottom: 35px;
  }
  .chat.answer .text p:last-of-type {
    padding-bottom: 35px;
  }
  .arrow-forward {
    transform: rotate(-90deg);
  }
  #carrousel {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding: 20px 0;
    /* Hide scrollbar */
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
  }
  #carrousel .carousel {
    display: flex;
    align-items: flex-end;
    gap: 16px;
    padding: 0 20px;
    width: 100%;
  }
  #carrousel .carousel::after {
    content: "&nbsp;";
    flex: 0 0 20px;
    width: 20px;
    color: transparent;
    /* Adjust this value to match the padding */
  }
  #carrousel .carousel .card {
    background-color: rgba(87, 87, 87, 0.9);
    color: #fff;
    flex: 0 0 80%;
    width: 258px;
    max-width: 258px;
    height: -moz-fit-content;
    height: fit-content;
    padding: 6px 12px;
    border-radius: 2px;
    scroll-snap-align: center;
    background: rgba(87, 87, 87, 0.9);
  }
  #carrousel .carousel .card p {
    color: #fff;
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    padding: 0;
    margin: 0;
  }
  #carrousel::-webkit-scrollbar {
    display: none;
  }
  #thematique {
    display: none !important;
  }
  #avertissement {
    height: 60px !important;
    text-align: center;
  }
  .duo-content {
    width: 95%;
    position: fixed;
    top: 10%;
  }
  .duo-content.expanded {
    height: 400px;
  }
}
@media (min-width: 374px) and (max-width: 820px) and (max-height: 750px) {
  .sherpa-container.keyboard-open #sherpa-entete {
    display: none;
  }
}
@media (min-width: 374px) and (max-width: 820px) {
  .people-viewport .people-name-container {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 0 !important;
  }
  .separator {
    display: none;
  }
}
/*******************************************/
/*                                         */
/* S'applique au écrans avec une Largeur   */
/* comprise entre 100px et 374px           */
/*                                         */
/*******************************************/
@media (min-width: 100px) and (max-width: 374px) {
  .rightWrapper {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
.custom-tooltip {
  width: 600px;
}

.feedback-input {
  text-align: left;
}

/*******************************************/
/*                                         */
/* S'applique au écrans avec une hauteur   */
/* de 799px et moins                       */
/*                                         */
/*******************************************/
@media (max-height: 799px) {
  .chat.answer {
    flex: 1 1 auto;
    overflow-y: auto;
    max-height: 180px;
  }
}
/*******************************************/
/*                                         */
/* S'applique au écrans avec une hauteur   */
/* de 699px et moins                       */
/*                                         */
/*******************************************/
@media (max-height: 699px) {
  .chat.answer {
    flex: 1 1 auto;
    overflow-y: auto;
    max-height: 120px;
  }
  .terms-wrapper .scrollable-section.terms-smal-viewport {
    max-height: 210px !important;
  }
  .terms-and-conditions .faq-wrapper .faq-scrollable-section, .terms-and-conditions .terms-wrapper .faq-scrollable-section {
    max-height: 370px;
    overflow-y: auto;
    padding-right: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/people/components/web/people-assistant-modal/people-assistant-modal.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAsJhB,sFAAA;AACA;;;EAAA;AAKA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AAEA,4BAAA;AACA;EACE,WAAA;EACA,UAAA;AAtJF;;AAyJA;EACE,mBAAA;EACA,6BAAA;EACA,yBAAA;AAtJF;;AAyJA;EACE,mBAAA;EACA,yBArDK;AAjGP;;AAyJA;EACE,yBAxDW;EAyDX,yBAAA;AAtJF;;AAyJA;EACE,yBA5DY;EA6DZ,yBAAA;AAtJF;;AA0JA;EACE;IACE,8BAAA;EAvJF;AACF;AA8JA;EACE,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,8BAAA;EACA,yEAAA;EACA,sBAAA;AA5JF;AA8JE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;AA5JJ;;AAgKA;EApLE,8BAnCiB;EAoCjB,eAhCgB;EAiChB,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,iBArBgB;EAsMlB,YAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;AAzJF;AA0JE;EACE,cAAA;AAxJJ;;AA4JA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;AAzJF;;AA4JA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;AAzJF;AA2JE;EACE,YAAA;AAzJJ;;AA6JA;EAzGM,iBAAA;EACA,gBAAA;AAhDN;;AA4JA;EACE,WApIM;EApFN,sCAlCqB;EAmCrB,eA5BmB;EA6BnB,kBA1BkB;EA2BlB,gBAtBqB;EAwBnB,mBAlBmB;EAyFrB,mBAtFwB;EAoOxB,aAAA;EACA,cAAA;EAtHE,UAAA;EACA,SAAA;AA7BJ;AAoJE;EA7NA,sCAlCqB;EAmCrB,eA5BmB;EA6BnB,kBA1BkB;EA2BlB,gBAtBqB;EAwBnB,mBAlBmB;EAyFrB,mBAtFwB;AA2F1B;AAgJE;EACE,wBAAA;AA9IJ;AAiJE;EACE,0BAAA;AA/IJ;;AAmJA;EACE,yBAAA;AAhJF;;AAoJA;EACE,wBAAA;EACA,yBAAA;AAjJF;;AAoJA;EACE,iBAAA;EACA,kBAAA;AAjJF;AAoJI;EACE,WAtKE;EApFN,8BAnCiB;EAoCjB,eA/BY;EAgCZ,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,mBApBY;EA2QV,gBAAA;AA9IN;;AAmJA;EACE,WAAA;EACA,cAAA;AAhJF;AAmJE;EACE,iBAAA;EACA,uBAAA;EACA,eAAA;AAjJJ;AAoJE;EACE,iBAAA;EACA,eAAA;EACA,WAAA;AAlJJ;;AAuJA;EApRE,8BAnCiB;EAoCjB,eA7BsB;EA8BtB,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,iBAnBe;EAoSjB,kBAAA;EACA,SAAA;EACA,iBAAA;AAhJF;AAiJE;EACE,SAAA;AA/IJ;AAiJE;EACE,cA1MI;EAuBF,iBAAA;EACA,gBAAA;AAqCN;AAgJI;EACE,kBAAA;EACA,QAAA;AA9IN;AA+IM;EACE,YAAA;AA7IR;;AAmJA;EACE,mBAAA;AAhJF;AAkJE;EACE,WA1NI;EApFN,8BAnCiB;EAoCjB,eA/BY;EAgCZ,kBA1BkB;EA2BlB,gBAvBiB;EAyBf,mBApBY;EAyHV,iBAAA;EACA,gBAAA;AA0DN;;AAqMA;EACE,0BAAA;AAlMF;;AAuMA;EACE,sBA7RM;EA8RN,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;AApMF;AAsME;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AApMJ;AAwME;EAEE,kBAAA;EACA,kBAAA;AAvMJ;AA4MM;EACE,eAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AA1MR;AA4MQ;EACE,cAAA;EACA,eAAA;AA1MV;AAkNM;EACE,cAAA;EACA,aAAA;AAhNR;AAmNM;EACE,eAAA;AAjNR;AAmNQ;EACE,gBAAA;EACA,eAAA;AAjNV;AAoNQ;EACE,eAAA;EACA,cAAA;AAlNV;;AAyNA;EACE,iBAAA;EACA,WAAA;AAtNF;AAuNE;EACE,kBAAA;AArNJ;AAuNE;EACE,kBAAA;EACA,WAAA;EACA,qBAAA;AArNJ;AAwNE;EAzbA,8BAnCiB;EAoCjB,eAhCgB;EAiChB,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,iBArBgB;EA2chB,iBAAA;EACA,4BAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,kDAAA;AAlNJ;AAqNE;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBA/WG;EAgXH,yBAAA;AAnNJ;AAqNI;EACE,yBAlXE;AA+JR;AAsNI;EACE,aAAA;AApNN;;AA0NA;EACE,gBAAA;EACA,YAAA;EAvXE,UAAA;EACA,SAAA;AAiKJ;AA0NI;EACE,+BAAA;AAxNN;AA0NM;EACE,yBAAA;AAxNR;AA4NI;EACE,+BAAA;AA1NN;AA4NM;EACE,yBAAA;AA1NR;AA8NI;EACE,+BAAA;AA5NN;AA8NM;EACE,yBAAA;AA5NR;AAiOE;EAEE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,sCAAA;AAhOJ;AAoOE;EACE,4BAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,+BAAA;AAlOJ;AAoOI;EACE,qBAAA;AAlON;AAsOE;EACE,gBAAA;AApOJ;;AAyOA;EACE,yBAAA;EACA,oBAAA;AAtOF;;AA0OA;EACE,gBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;EACA,sBA7cM;AAsOR;;AAkPI;EACE,cA1dE;EAnFN,8BAnCiB;EAoCjB,eAhCgB;EAiChB,kBA1BkB;EA2BlB,gBAvBiB;EAyBf,iBArBgB;AAmVpB;AA+OE;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;AA7OJ;AA+OI;EACE,iBAAA;AA7ON;AAgPI;EACE,gBAAA;AA9ON;AAiPI;EACE,oBAAA;AA/ON;AAuPE;EACE,4BAAA;EACA,gBAAA;EACA,YAAA;EACA,UA9eE;AAyPN;;AA0PA;EACE,iBAAA;EAGA,sBAAA;EACA,YAAA;AAzPF;AA0PE;EACE,8BAAA;AAxPJ;AA0PE;EACE,8BAAA;AAxPJ;AA5CE;EACE,oCAAA;EACA,cAvOI;EAwOJ,kDAAA;AA8CJ;AA3CE;EACE,iCAAA;EACA,6BAAA;EACA,yBAAA;EACA,kDAAA;AA6CJ;AA1CE;EACE,aAAA;EACA,iBAAA;AA4CJ;AAzCE;EACE,wCAAA;EACA,sBAAA;EACA,iCAAA;AA2CJ;AAzCI;EACE,oCAAA;EACA,yBAAA;AA2CN;AAvCE;EACE,wCAAA;EACA,yBAAA;EACA,mBAAA;AAyCJ;AAuOE;EACE,cAAA;EACA,kBAAA;AArOJ;AAuOI;EACE,iBAAA;AArON;AAwOI;EACE,sBAAA;EACA,YAAA;AAtON;AAyOI;EACE,aAAA;AAvON;;AA4OA;EACE,kBAAA;AAzOF;AA2OE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;AAzOJ;AA2OI;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,qBA3iBC;AAkUP;AA6OI;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;AA3ON;AA6OM;EACE,mBAAA;AA3OR;;AAiPA;EACE,WAAA;EACA,YAAA;AA9OF;;AAmPA;EACE,iBAAA;AAhPF;;AAoPA;EACE,YAAA;EACA,yBAllBK;EAmlBL,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAjPF;;AAuPA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AApPF;;AAuPA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;AApPF;;AAuPA;EACE,YAAA;EACA,eAAA;EACA,QAAA,EAAA,gCAAA;EACA,SAAA;EACA,2BAAA;EACA,uBAAA;EACA,oBAAA;EACA,yCAAA;EACA,aAAA;EACA,kBAAA;EACA,0BAAA;AApPF;AAqPE;EACE,aAAA;AAnPJ;AAqPE;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,SAAA;AAnPJ;AAoPI;EAvtBF,8BAnCiB;EAoCjB,eAhCgB;EAiChB,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,iBArBgB;EAyuBd,WAroBE;EAsoBF,iBAAA;EACA,YAAA;EACA,kBAAA;AA9ON;AA+OO;EACC,yBAjoBD;AAoZP;AA8OQ;EACE,yBA3oBH;AA+ZP;AA+OM;EACE,yBA1oBG;AA6ZX;AA+OM;EACE,yBAzoBA;AA4ZR;;AA6PA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AA1PF;;AA6PA;EACE,kBAAA;AA1PF;AA2PE;EACE,4BAAA;EACA,SAAA;EAnwBF,8BAnCiB;EAoCjB,eA/BY;EAgCZ,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,mBApBY;EAoxBZ,cA3qBO;EA4qBP,YAAA;EACA,gCAAA;AArPJ;AAsPI;EACE,cAhrBM;AA4bZ;;AAyPA;EACE,WAAA;EACA,mBAAA,EAAA,iDAAA;AAtPF;;AAyPA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AAtPF;;AAyPA;EACE,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAtPF;AAuPE;EACE,uBAAA;AArPJ;AAuPE;EACE,SAAA;AArPJ;AAsPK;EACC,aAAA;AApPN;AAsPI;EA/yBF,8BAnCiB;EAoCjB,eA9Be;EA+Bf,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,iBAnBe;EA+zBb,cAxtBM;AAweZ;AAmPE;EApzBA,8BAnCiB;EAoCjB,eA9Be;EA+Bf,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,iBAnBe;EAo0Bf,cA7tBQ;EA8tBR,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;AA7OJ;;AAiPA;EA9zBE,8BAnCiB;EAoCjB,eAhCgB;EAiChB,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,iBArBgB;EAg1BlB,cA7uBM;EA8uBN,iBAAA;EACA,gCAAA;EACA,iBAAA;EACA,eAAA;AA1OF;AA2OE;EACE,yBA9uBS;AAqgBb;AA2OE;EACE,mBAAA;AAzOJ;AA4OE;EA50BA,8BAnCiB;EAoCjB,eA9Be;EA+Bf,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,iBAnBe;EA41Bf,cArvBQ;AA+gBZ;AAyOE;EAj1BA,8BAnCiB;EAoCjB,eAhCgB;EAiChB,kBA1BkB;EA2BlB,gBAvBiB;EAyBf,iBArBgB;AA+nBpB;;AAuOA;EACE,SAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AApOF;AAqOE;EACE,kBAAA;EACA,SAAA;AAnOJ;AAqOE;EA/1BA,8BAnCiB;EAoCjB,eAhCgB;EAiChB,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,iBArBgB;EAi3BhB,WA7wBI;AA8iBR;AAiOI;EACE,mBAAA;EACA,yBAlxBE;EAmxBF,yBAAA;AA/NN;AAgOM;EACE,6BAAA;EACA,eAAA;AA9NR;AA+NQ;EACE,WAAA;EACA,YAAA;AA7NV;;AAsOA;EACE,iBAAA;EACA,qBAAA;AAnOF;AAqOE;EACE,WAtyBI;EApFN,8BAnCiB;EAoCjB,eA/BY;EAgCZ,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,mBApBY;EA24BZ,iBAAA;AA/NJ;AAiOI;EA93BF,8BAnCiB;EAoCjB,eAhCgB;EAiChB,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,iBArBgB;AAorBpB;AA6NM;EACE,iBAAA;AA3NR;AAiOE;EACE,WAAA;EACA,oBAAA;AA/NJ;AAiOI;EACE,kBAAA;EACA,eAAA;AA/NN;AAiOM;EACE,WA7zBA;EApFN,8BAnCiB;EAoCjB,eA/BY;EAgCZ,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,mBApBY;EAk6BR,kBAAA;EACA,yBAzzBM;EA0zBN,oBAAA;EACA,yBAAA;EACA,yBAAA;AA3NR;AA6NQ;EACE,cA/zBI;EAg0BJ,sBAv0BF;AA4mBR;AA+NM;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;EACA,YAAA;AA7NR;AA+NQ;EACE,WAAA;EACA,6BAAA;AA7NV;AAgOQ;EACE,WAx1BF;EApFN,8BAnCiB;EAoCjB,eAhCgB;EAiChB,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,iBArBgB;EA87BV,kBAAA;AA1NV;AAgOE;EACE,cAl2BI;EAnFN,8BAnCiB;EAoCjB,eAhCgB;EAiChB,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,iBArBgB;EAu8BhB,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAt2BI;EAu2BJ,mBAAA;EACA,yBAAA;EACA,eAAA;EACA,sCAAA;AA1NJ;AA4NI;EACE,cA92BE;EA+2BF,yBAt2BW;AA4oBjB;AA6NI;EACE,mBAAA;AA3NN;AA+NE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,6BAAA;EACA,+BAAA;AA7NJ;AA+NI;EACE,0BAAA;AA7NN;AAgOI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AA9NN;;AAmOA;EACE,WAAA;AAhOF;AAkOE;EACE,YAAA;EACA,eAAA;AAhOJ;AAmOE;EACE,cAv5BI;EAnFN,8BAnCiB;EAoCjB,eAhCgB;EAiChB,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,iBArBgB;EA4/BhB,iBAAA;EACA,yBAr5BS;EAs5BT,mBAAA;EACA,WAAA;EACA,yBAAA;AA7NJ;AA+NI;EAEE,WAh6BE;EAi6BF,yBA35BK;AA6rBX;;AAmOA;EACE,kBAAA;EACA,2EAAA;EACA,UAAA;EACA,YAAA;EACA,oBAAA;EACA,UAAA;AAhOF;;AAmOA;EACE,eAAA;EACA,YAAA;EACA,WAAA;AAhOF;;AAmOA;EACE,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,sCAAA;AAhOF;AAkOE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AAhOJ;AAmOE;EACE,mBA/7Ba;AA8tBjB;;AAqOA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,QAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yCAAA;AAlOF;;AAqOA;EACE,cAx9BM;EAy9BN,cAAA;EACA,WAAA;EA7iCA,8BAnCiB;EAoCjB,eA9Be;EA+Bf,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,iBAnBe;EA6jCjB,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,sCAAA;AA9NF;AAgOE;EACE,gCAAA;AA9NJ;;AAkOA;EACE,yBAh+Be;AAiwBjB;;AAkOA;EACE,kBAAA;AA/NF;AAiOE;EACE,WA/+BI;EApFN,8BAnCiB;EAoCjB,eA/BY;EAgCZ,kBA1BkB;EA2BlB,gBAvBiB;EAyBf,mBApBY;EAolCZ,kBAAA;AA3NJ;AA4NI;EACE,YAAA;AA1NN;;AA+NA;EACE,oBAAA;AA5NF;;AA+NA;;EAEE,oBAAA;AA5NF;;AA+NA;;EAEE,sBAngCM;EAogCN,mBAAA;EACA,kBAAA;AA5NF;;AA+NA;EACE,2BAAA;AA5NF;;AA+NA;EACE,2BAAA;AA5NF;;AA+NA;EACE,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AA5NF;AA8NE;EACE,WAAA;AA5NJ;;AAmOE;;EAEE,mBAAA;AAhOJ;AAkOI;;EACE,cApiCE;EAnFN,8BAnCiB;EAoCjB,eAhCgB;EAiChB,kBA1BkB;EA2BlB,gBAvBiB;EAyBf,iBArBgB;EAyoCd,oBAAA;AA3NN;AA8NI;;EACE,cAniCK;EA1FT,8BAnCiB;EAoCjB,eAhCgB;EAiChB,kBA1BkB;EA2BlB,gBAvBiB;EAyBf,iBArBgB;AAu7BpB;AA0NI;;EACE,cAxiCK;EA1FT,8BAnCiB;EAoCjB,eAhCgB;EAiChB,kBA1BkB;EA2BlB,gBAvBiB;EAyBf,iBArBgB;AAg8BpB;AAsNI;;EACE,cA7iCK;EA1FT,8BAnCiB;EAoCjB,eAhCgB;EAiChB,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,iBArBgB;AAy8BpB;AAkNI;;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;AA/MN;AAgNM;;EACE,iBAAA;AA7MR;AAiNI;;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;AA9MN;AAkNE;EACE,oBAAA;AAhNJ;AAmNE;EACE,eAAA;EACA,mBAAA;AAjNJ;AAmNI;EACE,kBAAA;AAjNN;AAsNI;EACE,cAvlCE;EAnFN,8BAnCiB;EAoCjB,eAhCgB;EAiChB,kBA1BkB;EA2BlB,gBAxBoB;EA0BlB,iBArBgB;EAqHhB,UAAA;EACA,SAAA;AAu3BJ;AAmNE;EACE,WA7lCI;EApFN,oBAkrCuC;EAjrCvC,eAirCsB;EAhrCtB,kBA1BkB;EA2BlB,gBA+qC4B;EA7qC1B,iBA6qC+B;EAC/B,iBAAA;EACA,kBAAA;EACA,yBAxlCG;EAylCH,sCAAA;AA7MJ;AA+MI;EACE,yBA3lCE;AA84BR;AAgNI;EACE,cAnmCK;EAomCL,yBAzmCC;EA0mCD,mBAAA;AA9MN;;AAmNA;EACE,kBAAA;EACA,QAAA;EACA,8BAAA;EACA,cAAA;AAhNF;;AAmNA;EACE,WAxnCM;EApFN,0BA6sCqC;EA5sCrC,eA4sCoB;EA3sCpB,kBA1BkB;EA2BlB,gBA0sC0B;EAxsCxB,iBAwsC6B;EAxmC7B,UAAA;EACA,SAAA;AA65BJ;;AA8MA;EACE,aAAA;AA3MF;;AA8MA;EACE,+BAAA;AA3MF;;AA8MA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AAEA;EACE;IACE,sCAAA;IACA,kBAAA;IACA,WAAA;IACA,uBAAA;EA5MF;EA+MA;IACE,kBAAA;EA7MF;EAgNA;IA5uCA,sCAlCqB;IAmCrB,eA5BmB;IA6BnB,kBA1BkB;IA2BlB,gBAtBqB;IAwBnB,mBAlBmB;IAyFrB,mBAtFwB;EA8iCxB;EA4MA;IACE,cAAA;EA1MF;EA6MA;IACE,uBAAA;EA3MF;EA8MA;IACE,cAAA;IACA,WAAA;EA5MF;EA+MA;IA7vCA,8BAnCiB;IAoCjB,eA7BsB;IA8BtB,kBA1BkB;IA2BlB,gBAxBoB;IA0BlB,iBAnBe;IA6wCf,0BAAA;IACA,SAAA;IACA,iBAAA;IACA,kBAAA;IACA,mBAAA;EAzMF;EA2ME;IACE,cAnrCE;IAuBF,iBAAA;IACA,gBAAA;EAo9BJ;EAyMI;IACE,kBAAA;IACA,QAAA;EAvMN;EA4MA;IACE,cAAA;EA1MF;EA8MA;IACE,cAAA;IACA,kBAAA;IACA,SAAA;EA5MF;EA6ME;IACE,kCAAA;IACA,YAAA;EA3MJ;EA+MA;IAzrCE,UAAA;IACA,SAAA;EA6+BF;EA+MA;IACE,kBAAA;IACA,SAAA;IACA,OAAA;EA7MF;EAgNA;IACE,kBAAA;IACA,sBAAA;EA9MF;EAiNA;IACE,qBAAA;EA/MF;EAiNE;IACE,oBAAA;IACA,WA9tCE;IA+tCF,eAAA;IACA,gBAAA;IACA,iBAAA;EA/MJ;EAmNA;IACE,oBAAA;IACA,uBAAA;EAjNF;EAoNA;IACE,mBAAA;EAlNF;EAqNA;IACE,iBAAA;EAnNF;EAsNA;IACE,gBAAA;EApNF;EAuNA;IACE,sBAAA;EArNF;EAwNA;IACE,WAAA;IACA,iBAAA;IACA,sBAAA;EAtNF;EAuNE;IACE,4BAAA;EArNJ;EAwNE;IAt1CF,8BAnCiB;IAoCjB,eAhCgB;IAiChB,kBA1BkB;IA2BlB,gBAxBoB;IA0BlB,iBArBgB;IAw2Cd,iBAAA;EAlNJ;EAqNE;IACE,gBAAA;IACA,eAAA;EAnNJ;EAsNE;IACE,gBAAA;IACA,iBAAA;EApNJ;EAuNE;IAr2CF,8BAnCiB;IAoCjB,eA9Be;IA+Bf,kBA1BkB;IA2BlB,gBAxBoB;IA0BlB,iBAnBe;IAq3Cb,iBAAA;EAjNJ;EAoNE;IA12CF,8BAnCiB;IAoCjB,eAhCgB;IAiChB,kBA1BkB;IA2BlB,gBAxBoB;IA0BlB,iBArBgB;IA43Cd,cAAA;EA9MJ;EAkNA;IACE,WAAA;EAhNF;EAmNA;IACE,eAAA;IACA,WAAA;EAjNF;EAoNA;IACE,kBAAA;IACA,2EAAA;IACA,UAAA;IACA,YAAA;IACA,UAAA;EAlNF;EAyNA;IACE,iBAAA;EAvNF;EA0NA;IACE,kBAAA;IACA,kBAAA;IAjyCE,cAAA;IACA,aAAA;EA0kCJ;EA0NA;IACE,mBAAA;EAxNF;AACF;AA2NA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA;EACE;IACE,YAAA;EAzNF;EA4NA;IACE,mBAAA;EA1NF;EA4NA;IACE,cAAA;EA1NF;EA6NA;IACE,kBAAA;IACA,mBAAA;EA3NF;EA8NA;IACE,sBAx1CI;IAy1CJ,mBAAA;IACA,uBAAA;IACA,sBAAA;EA5NF;EAgOA;IACE,WAAA;IACA,kBAAA;EA9NF;EAiOA;IACE,WAAA;EA/NF;EAkOA;IACE,eAAA;EAhOF;AACF;AAmOA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA;EAEE;IACE,0BAAA;EAlOF;EAoOA;IACE,WAAA;IACA,cAAA;IACA,iBAAA;EAlOF;EAqOA;IACE,WAAA;IACA,kBAAA;IACA,mBAAA;IACA,cAAA;EAnOF;EAsOA;IACE,kBAAA;IACA,mBAAA;EApOF;EAuOA;IACI,cAAA;IACA,WAAA;EArOJ;EAsOI;IACE,iBAAA;EApON;EAqOM;IACE,WAAA;IACA,cAAA;EAnOR;EAoOQ;IACE,WAAA;EAlOV;AACF;AAwOA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA;EACE;IACE,kBAAA;EAtOF;EAyOA;IACE,kBAAA;IACA,SAAA;IACA,WAAA;EAvOF;EA0OA;IACE,kBAAA;IACA,SAAA;IACA,WAAA;EAxOF;EA2OA;IACE,aAAA;EAzOF;EA0OE;IACE,6BAAA;EAxOJ;EA4OA;IACE,cAAA;EA1OF;AACF;AA8OA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,+DAAA;AACA;EAGI;IACE,8BAAA;EA9OJ;EAkPA;IACE,kBAAA;IACA,eAAA;EAhPF;EAmPA;IACE,eAAA;IACA,WAAA;IACA,aAAA;EAjPF;EAmPA;IACE,WAAA;IACA,eAAA;IACA,eAAA;EAjPF;EAmPA;IACG,uBAAA;EAjPH;EAoPE;IACE,gBAAA;EAlPJ;EAuPI;IACE,kCAAA;EArPN;EA0PI;IACE,kCAAA;EAxPN;EA6PA;IACE,YAAA;IACA,yBA5+Ca;IA6+Cb,8BAAA;EA3PF;EA6PE;IACE,kBAAA;IACA,yBAl/CQ;IAm/CR,kBAAA;IACA,0BAAA;EA3PJ;EA6PI;IACE,gBAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;IACA,kBAAA;IACA,sBAngDA;IAogDA,kDAAA;IACA,aAAA;EA3PN;EA6PM;IACE,cAngDE;IAzFV,oBA6lD4C;IA5lD5C,cA4lD4B;IA3lD5B,kBA1BkB;IA2BlB,gBA0lDiC;IAxlD/B,iBAwlDoC;IAC9B,yBAAA;IACA,aAAA;IACA,WAAA;IACA,gCAAA;EAvPR;EA0PM;IACE,aAAA;IACA,8BAAA;IACA,mBAAA;IACA,WAAA;IACA,mBAAA;IACA,sBAthDF;IAuhDE,cAxhDF;IAnFN,8BAnCiB;IAoCjB,eA9Be;IA+Bf,kBA1BkB;IA2BlB,gBAxBoB;IA0BlB,iBAnBe;IA2nDT,sBAAA;EApPR;EAsPQ;IACE,oBAAA;EApPV;EA0PE;IACE,WAAA;EAxPJ;EA0PI;IACE,iBAAA;IACA,cAxiDA;IAyiDA,kBAAA;IACA,kBAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,iBAAA;EAxPN;EA8PA;IACE,kBAAA;IACA,aAAA;IACA,WAAA;IACA,WAAA;IACA,yBAAA;IACA,cAAA;IACA,gBAAA;IACA,uJAAA;EA5PF;EAiQA;IACE,wBAAA;EA/PF;EAkQA;IACE,UAAA;IACA,yDAAA;EAhQF;EAmQA;IACE,sBAAA;EAjQF;EAoQA;;IAEE,WAAA;IACA,uBAAA;IACA,wGAAA;EAlQF;EAsQA;IACE,yCAAA;EApQF;EAuQA;IACE,yCAAA;EArQF;EA0QA;IACE,yBAAA;IACA,0BAAA;EAxQF;EA2QA;IACE,qBAAA;IACA,4BAAA;EAzQF;EA4QA;IACE,2BAAA;IACA,yBAAA;IACA,iBAAA;IACA,YAAA;IACA,8BAAA;IACA,6DAAA;EA1QF;EA6QA;IACE,iBAAA;IACA,cAAA;IACA,sBAAA;EA3QF;EA6QE;IACE,aAAA;EA3QJ;EAgRA;IACE,yCAAA;IACA,WAAA;IACA,cAAA;IACA,kBAAA;IACA,gCAAA;IACA,kBAAA;IACA,cAAA;EA9QF;EA+QE;IACE,+BAAA;EA7QJ;EAiRA;IACE,iCAAA;EA/QF;EAkRA;IACE,MAAA;IACA,0BAAA;EAhRF;EAkRE;IACE,UAAA;IACA,cAAA;EAhRJ;EAoRA;IAloDI,cAAA;IACA,aAAA;IAmoDF,UAAA;EAjRF;EAsRI;IACE,kBAAA;IACA,YAAA;EApRN;EAyRA;IACE,kBAAA;EAvRF;EAyRE;IACE,qBAAA;IACA,yBAAA;EAvRJ;EA4RA;IACE,WAAA;IACA,eAAA;IACA,aAAA;EA1RF;EA6RA;IACE,cAAA;IACA,gBAAA;IACA,iBAAA;EA3RF;EA4RE;IACE,cAAA;IACA,mBAAA;EA1RJ;EA8RA;IACE,iBAAA;EA5RF;EA8RD;IACG,aAAA;EA5RF;EA8RA;IACE,cAAA;IACA,gBAAA;IACA,iBAAA;EA5RF;EA+RA;IACE,UAAA;IACA,UAAA;EA7RF;EAgSA;IACE,oBAAA;EA9RF;EAmSI;IACE,oBAAA;EAjSN;EAsSA;IACE,yBAAA;EApSF;EAuSA;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,kBAAA;IACA,6BAAA;IACA,iCAAA;IACA,eAAA;IAuCA,mBAAA;IAKA,wBAAA;IACA,gBAAA;IACA,qBAAA;IACA,YAAA;EA/UF;EAkSE;IACE,aAAA;IACA,qBAAA;IACA,SAAA;IACA,eAAA;IACA,WAAA;EAhSJ;EAkSI;IACE,iBAAA;IACA,cAAA;IACA,WAAA;IACA,kBAAA;IACA,2CAAA;EAhSN;EAoSI;IACE,uCAAA;IACA,WA9vDA;IA+vDA,aAAA;IACA,YAAA;IACA,gBAAA;IACA,wBAAA;IAAA,mBAAA;IACA,iBAAA;IACA,kBAAA;IACA,yBAAA;IACA,iCAAA;EAlSN;EAoSM;IACE,WAzwDF;IA0wDE,gBAAA;IA91DR,8BAnCiB;IAoCjB,eA9Be;IA+Bf,kBA1BkB;IA2BlB,gBAxBoB;IA0BlB,iBAnBe;IAmHf,UAAA;IACA,SAAA;EA69CF;EAmSE;IACE,aAAA;EAjSJ;EA6SA;IACE,wBAAA;EA3SF;EA8SA;IACE,uBAAA;IACA,kBAAA;EA5SF;EAgTA;IACE,UAAA;IACA,eAAA;IACA,QAAA;EA9SF;EA+SE;IACE,aAAA;EA7SJ;AACF;AAgTC;EAGK;IACE,aAAA;EAhTN;AACF;AAlEA;EAsXI;IACE,sBAAA;IACA,2BAAA;IACA,uBAAA;IACA,iBAAA;EAjTJ;EAqTA;IACE,aAAA;EAnTF;AACF;AAsTA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA;EACE;IACE,yBAAA;IACA,0BAAA;EApTF;AACF;AAuTA;EACE,YAAA;AArTF;;AAyTA;EACE,gBAAA;AAtTF;;AAyTA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA;EACE;IACE,cAAA;IACA,gBAAA;IACA,iBAAA;EAtTF;AACF;AAyTA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA,4CAAA;AACA;EACE;IACE,cAAA;IACA,gBAAA;IACA,iBAAA;EAvTF;EAyTA;IACE,4BAAA;EAvTF;EAyTF;IACE,iBAAA;IACA,gBAAA;IACA,mBAAA;EAvTA;AACF","sourcesContent":["// Font Variables\n\n// Base Font\n$font-family-base: Arial, sans-serif;\n$font-family-logotype: 'Arial Black', sans-serif;\n\n// Font Sizes\n$font-size-small: 15px;\n$font-size-p: 24px;\n$font-size-note: 13px;\n$font-size-alternative: 12px;\n$font-size-logotype: 40px;\n\n// Font Styles\n$font-style-normal: normal;\n\n// Font Weights\n$font-weight-regular: 400;\n$font-weight-bold: 700;\n$font-weight-logotype: 900;\n\n// Line Heights\n$line-height-small: 24px; // 160%\n$line-height-p: normal;\n$line-height-note: 18px;\n$line-height-logotype: normal;\n\n// Letter Spacing\n$letter-spacing-logotype: 0px;\n\n// Font Variables\n///\n/// @param {*} $size\n/// @param {*} $weight [$font-weight-regular]\n/// @param {*} $line-height [null]\n/// @param {*} $family [$font-family-base]\n\n@mixin text-style($size, $weight: $font-weight-regular, $line-height: null, $family: $font-family-base) {\n  font-family: $family;\n  font-size: $size;\n  font-style: $font-style-normal;\n  font-weight: $weight;\n  @if $line-height != null {\n    line-height: $line-height;\n  }\n}\n\n// Usage\n///\n/// @param {*} $font-size-small // 15px\n/// @param {*} $font-weight-regular // 400\n/// @param {*} $line-height-small // 24px\n\n@mixin small-text {\n  @include text-style($font-size-small, $font-weight-regular, $line-height-small);\n}\n\n///\n/// @param {*} $font-size-small // 15px\n/// @param {*} $font-weight-bold // 700\n/// @param {*} $line-height-small // 24px\n\n@mixin small-text-bold {\n  @include text-style($font-size-small, $font-weight-bold, $line-height-small);\n}\n\n///\n/// @param {*} $font-size-p // 24px\n/// @param {*} $font-weight-regular // 400\n/// @param {*} $line-height-p // normal\n\n@mixin p-text {\n  @include text-style($font-size-p, $font-weight-regular, $line-height-p);\n}\n\n///\n/// @param {*} $font-size-p // 24px\n/// @param {*} $font-weight-bold // 700\n/// @param {*} $line-height-p // normal\n\n@mixin p-text-bold {\n  @include text-style($font-size-p, $font-weight-bold, $line-height-p);\n}\n\n// Note Text Mixin\n///\n/// @param {*} $font-size-note // 13px\n/// @param {*} $font-weight-regular // 400\n/// @param {*} $line-height-note // 18px\n\n@mixin note-text {\n  @include text-style($font-size-note, $font-weight-regular, $line-height-note);\n}\n\n// Alternative Text Mixin\n///\n/// @param {*} $font-size-alternative // 12px\n/// @param {*} $font-weight-regular // 400\n/// @param {*} $line-height-note // 18px\n\n@mixin alternative-text {\n  @include text-style($font-size-alternative, $font-weight-regular, $line-height-note);\n}\n\n// Logotype Text Mixin\n///\n/// @param {*} $font-size-logotype // 40px\n/// @param {*} $font-weight-logotype // 900\n/// @param {*} $line-height-logotype // normal\n/// @param {*} $font-family-logotype // 'Arial Black', sans-serif\n/// @param {*} ;letter-spacing [$letter-spacing-logotype;}]\n\n@mixin logotype-text {\n  @include text-style($font-size-logotype, $font-weight-logotype, $line-height-logotype, $font-family-logotype);\n  letter-spacing: $letter-spacing-logotype;\n}\n\n// Continue similarly for note-text, alternative-text, etc.\n\n\n// Color Variables\n$black: #111111;\n$white: #fff;\n$gray: #EDF2F5;\n$hover-gray: #007566;\n$active-gray: #007566;\n$light-gray: #F7F5F2;\n$dark-gray: #111111;\n$charcoal: #111111;\n$brand-green: #007566;\n$accent-overlay: #E1FFF0;\n$bleu: #007566;\n$marin: #007566;\n$red: red;\n\n// Spacing and Layout Mixins\n// Mixin to reset padding and margin\n@mixin reset-padding-margin($sides: 'all') {\n  @if $sides == 'all' {\n    padding: 0;\n    margin: 0;\n  }\n  @else {\n    @each $side in $sides {\n      padding-#{$side}: 0;\n      margin-#{$side}: 0;\n    }\n  }\n}\n\n/* Firefox (uncomment to work in Firefox, although other properties will not work!)  */\n/** {\n  scrollbar-width: thin;\n  scrollbar-color: #CCCCCC #FFFFFF;\n}*/\n\n/*******************************************/\n/*                                         */\n/* S'applique à tous les tailles d'écrans  */\n/*                                         */\n/*******************************************/\n\n/* Chrome, Edge and Safari */\n*::-webkit-scrollbar {\n  height: 5px;\n  width: 5px;\n}\n\n*::-webkit-scrollbar-track {\n  border-radius: 28px;\n  background-color: transparent;\n  border: 1px solid $gray;\n}\n\n*::-webkit-scrollbar-thumb {\n  border-radius: 20px;\n  background-color: $gray;\n}\n\n*::-webkit-scrollbar-thumb:hover {\n  background-color: $hover-gray;\n  border: 1px solid $hover-gray;\n}\n\n*::-webkit-scrollbar-thumb:active {\n  background-color: $active-gray;\n  border: 1px solid $active-gray;\n\n}\n\n@supports (-webkit-touch-callout: none) {\n  html, body {\n    height: -webkit-fill-available;\n  }\n}\n\n// .rightWrapper {\n//   margin-right: unset;\n// }\n\n.background-wrapper {\n  position: relative;\n  min-height: 100vh;\n  height: 100%;\n  height: -webkit-fill-available;\n  /* This makes sure the wrapper takes up the full height of the viewport */\n  background-image: none;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    display: none;\n    z-index: 0;\n  }\n}\n\n.sherpa-container {\n  @include small-text;\n  width: 950px;\n  margin: 0 auto;\n  height: 100vh;\n  position: relative;\n  z-index: 1000;\n  &.mobile {\n    height: 100svh;\n  }\n}\n\n#avertissement {\n  flex: 1 1 auto;\n  position: absolute;\n  bottom: 0;\n}\n\n.page {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  margin: 0 auto;\n  padding-bottom: 24px;\n\n  &__txt {\n    margin: auto;\n  }\n}\n\n.page-chatwindowvisible {\n  @include reset-padding-margin('bottom');\n}\n\n.txt {\n  color: $white;\n  @include logotype-text;\n  display: flex;\n  margin: 0 auto;\n  @include reset-padding-margin;\n  &.chat-window-visible {\n    @include logotype-text;\n  }\n\n  &__character {\n    transform: translateX(0);\n  }\n\n  &.terms {\n    font-size: 50px!important;\n  }\n}\n\n.entete {\n  padding: 50px 9px 9px 9px;\n\n}\n\n.entete-chat-window-visible {\n  padding: 9px 9px 0px 9px;\n  margin: 0 auto !important;\n}\n\n#sherpa-entete {\n  margin: 12px auto;\n  margin-bottom: 3px;\n\n  .sous-entete {\n    h2 {\n      color: $white;\n      @include p-text;\n      font-weight: 700;\n    }\n  }\n}\n\n#sherpa-chat {\n  width: 100%;\n  margin: 0 auto;\n\n\n  .report-button-container {\n    margin: 12px 12px;\n    padding: 12px 12px 40px;\n    margin-top: 3px;\n  }\n\n  .chat-window {\n    margin: 12px auto;\n    margin-top: 3px;\n    width: 100%;\n    ;\n  }\n}\n\n.avertissement-question {\n  @include alternative-text;\n  position: relative;\n  top: 49px;\n  margin-top: -36px;\n  &.duo-mode {\n    top: 60px;\n  }\n  p {\n    color: $black;\n    @include reset-padding-margin('bottom');\n    \n    &:last-of-type {\n      position: relative;\n      top: 1px;\n      &.duo-mode {\n        height: 36px;\n      }\n    }\n  }\n}\n\n.question-sub-header {\n  padding: 30px 0 0 0;\n\n  p {\n    color: $white;\n    @include p-text-bold;\n    @include reset-padding-margin('bottom');\n  }\n}\n\n\n\n// Mixin for button styles\n@mixin button-styles {\n  &:hover {\n    background-color: $accent-overlay !important;\n    color: $black;\n    box-shadow: 0px 4px 13.1px 0px rgba(0, 0, 0, 0.25);\n  }\n\n  &.selected {\n    background-color: $white !important;\n    border-color: $white !important;\n    color: $black !important;\n    box-shadow: 0px 4px 13.1px 0px rgba(0, 0, 0, 0.25);\n  }\n\n  &:focus {\n    outline: none;\n    outline-offset: 0;\n  }\n\n  &:not(.selected) {\n    background-color: transparent !important;\n    color: $white !important;\n    border: 1px solid $white !important;\n\n    &:hover {\n      background-color: $accent-overlay !important;\n      color: $black !important;\n    }\n  }\n\n  &:disabled {\n    background-color: transparent !important;\n    color: $gray !important;\n    cursor: not-allowed;\n  }\n}\n// Common font-size for elements\n// div.x-close,\n// div.chat.question span,\n// div.loading-indicator,\n// div.chat.answer span,\n// input.feedback-input,\n// button.modalButton,\n// button.iconButton,\n// button.btn-next-question,\n// div.feedback-received-box {\n//   font-size: 15px;\n// }\n\n// Modal styles\n\n.modal-body {\n  border-radius: 0 0 5px 5px;\n}\n\n\n\n.chat-messages {\n  background-color: $white;\n  border-radius: 26px;\n  padding: 24px 24px 12px;\n  margin: 12px auto;\n  width: 100%;\n  \n  .chat-message-body {\n    overflow-y: auto;\n    overflow-x: hidden;\n    margin-bottom: 20px;\n    max-height: 200px;\n\n  }\n\n  .chat-messages-bottom {\n    // height: 300px;\n    overflow-y: hidden;\n    overflow-x: hidden;\n\n\n    // Left buttons\n    .left-buttons {\n      .iconButton {\n        margin: 5px 6px;\n        padding: 0 3px;\n        margin-left: 0;\n        padding-left: 0;\n\n        &:first-of-type {\n          margin-left: 0;\n          padding-left: 0;\n        }\n      }\n    }\n\n\n\n    .right-buttons {\n      span {\n        padding: 0 9px;\n        margin: 0 9px;\n      }\n\n      .iconButton {\n        margin: 5px 5px;\n\n        &:first-of-type {\n          margin-left: 6px;\n          margin-right: 0;\n        }\n\n        &:last-of-type {\n          margin-right: 0;\n          margin-left: 0;\n        }\n      }\n    }\n  }\n}\n\n.chat-input {\n  padding-top: 10px;\n  width: 100%;\n  select {\n    margin-right: 10px;\n  }\n  .input-wrapper {\n    position: relative;\n    width: 100%;\n    display: inline-block;\n  }\n\n  input {\n    @include small-text;\n    line-height: 18px;\n    padding: 18px 60px 18px 24px;\n    border: none;\n    border-radius: 28px;\n    width: 100%;\n    box-shadow: 0px 4px 13.1px 0px rgba(0, 0, 0, 0.25);\n  }\n\n  .chat-buttons {\n    position: absolute;\n    right: 7px;\n    top: 5px;\n    height: 44px;\n    width: 44px;\n    border-radius: 50%;\n    text-align: center;\n    border: none;\n    background-color: $bleu;\n    transition: all 0.3s ease;\n\n    &:hover {\n      background-color: $marin;\n    }\n\n    .arrow-forward {\n      padding: 10px;\n    }\n  }\n}\n\n// Icon buttons\n.iconButton {\n  background: none;\n  border: none;\n  @include reset-padding-margin;\n\n  // margin-right: 5px;\n  .icon {\n    &.refresh {\n      transition: transform 0.6s ease;\n\n      &:hover {\n        transform: rotate(180deg);\n      }\n    }\n\n    &.thumbs_up {\n      transition: transform 0.4s ease;\n\n      &:hover {\n        transform: rotate(-30deg);\n      }\n    }\n\n    &.thumbs_down {\n      transition: transform 0.4s ease;\n\n      &:hover {\n        transform: rotate(-30deg);\n      }\n    }\n  }\n\n  &.thumbs-up-button,\n  &.thumbs-down-button {\n    border-radius: 10px;\n    width: 30px;\n    height: 30px;\n    background-color: transparent;\n    transition: background-color 0.8s ease;\n\n  }\n\n  &.copy-to-clipboard {\n    padding-left: 3px!important;\n    width: 30px;\n    height: 30px;\n    background-color: transparent;\n    transition: transform 0.4s ease;\n\n    &:hover {\n      transform: scale(1.1);\n    }\n  }\n\n  &:disabled {\n    background: none;\n  }\n}\n\n// Loading indicator\n.loading-indicator {\n  padding: 10px 35px 20px 0;\n  font-family: 'Arial';\n}\n\n// Chat styles\n.chat-question-container {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  padding: 0 0 18px 0;\n  background-color: $white;\n}\n\n.chat {\n\n\n\n\n  &.question {\n\n\n    .text {\n      color: $black;\n      @include small-text-bold;\n    }\n  }\n\n  &.answer {\n    padding: 0 25px 0 0;\n    margin-bottom: 0;\n    max-height: 274px;\n    transition: max-height 0.3s ease;\n\n    p {\n      line-height: 23px;\n    }\n\n    &.reduced {\n      max-height: 50px;\n    }\n\n    .text {\n      padding-bottom: 20px;\n    }\n\n    // &.reduced-feedback {\n    //   max-height: 194px;\n    // }\n  }\n\n  &.error-message {\n    padding: 20px 35px 20px 20px;\n    margin-bottom: 0;\n    height: 100%;\n    color: $red;\n  }\n}\n\n// Button styles\n.btn-report {\n  padding: 8px 60px;\n  // color: #000;\n  // background-color: transparent;\n  border: 1px solid $white;\n  width: 215px;\n  &.personalite {\n    border-radius: 2px 0px 0px 2px;\n  }\n  &.duo {\n    border-radius: 0px 2px 2px 0px;\n  }\n\n  &.personalite,\n  &.talents,\n  &.iac,\n  &.pcr,\n  &.duo {\n    @include button-styles;\n  }\n\n\n  &.chat-buttons {\n    flex: 1 1 auto;\n    text-align: center;\n\n    &.btn-next-question {\n      margin-left: auto;\n    }\n\n    &:last-child {\n      max-width: max-content;\n      flex: 1 0 0%;\n    }\n\n    &:not(:first-child):not(:last-child) {\n      margin: 0 5px;\n    }\n  }\n}\n\n.personality-button-container {\n  position: relative;\n\n  .radio-button {\n    position: absolute;\n    top: 51px;\n    left: 0;\n\n    input[type=\"radio\"] {\n      height: 20px;\n      width: 20px;\n      margin-top: 0;\n      cursor: pointer;\n      accent-color: $bleu;\n      // height: 0;\n    }\n\n    label {\n      position: relative;\n      padding-left: 10px;\n      color: white;\n      padding-right: 10px;\n\n      &:first-of-type {\n        padding-right: 24px;\n      }\n    }\n  }\n}\n\n.icon-disabled-radio {\n  width: 20px;\n  height: 20px;\n}\n\n\n// Close button\n.x-close {\n  margin-left: 10px;\n}\n\n// style=\"width: 114px; background-color: #EDF2F5; opacity: 30%; height: 1px; border: none; margin-top: 48px; margin-bottom: 30px;\"\n.hr-jil {\n  width: 114px;\n  background-color: $gray;\n  opacity: 30%;\n  height: 1px;\n  border: none;\n  margin: 58px 0 16px;\n  // &.duo-mode {\n  //   margin: 77px 0 16px;\n  // }\n}\n\n.people-dropdown {\n  width: 100%;\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.duo-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n}\n\n.duo-content {\n  width: 598px;\n  position: fixed;\n  top: 20%; /* Adjust this value as needed */\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: white;\n  padding: 0 12px 12px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  z-index: 1001;\n  border-radius: 8px;\n  transition: height 1s ease;\n  &.expanded {\n    height: 400px;\n  }\n  .button-container {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 12px;\n    gap: 12px;\n    button {\n      @include small-text;\n      color: $white;\n      padding: 6px 12px;\n      width: 109px;\n      border-radius: 2px;\n       &.add {\n        background-color: $bleu;\n        &:disabled {\n          background-color: $gray;\n        }\n      }\n      &.cancel {\n        background-color: $charcoal;\n      }\n      &.reset {\n        background-color: $marin;\n      } \n    }\n  }\n}\n\n// .scroll-container {\n//   height: 0; /* Adjust as needed */\n//   overflow: auto;\n//   border: 1px solid #ccc;\n//   border-radius: 4px;\n//   &.expanded {\n//     height: 200px; /* Adjust as needed */\n//   }\n// }\n\n.search-input {\n  width: 100%;\n  padding: 10px;\n  margin: 10px 0;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.input-container {\n  position: relative;\n  input {\n    padding: 16px 16px 16px 12px;\n    margin: 0;\n    @include p-text;\n    color: $charcoal;\n    border: none;\n    border-bottom: 1px solid $gray;\n    &::placeholder {\n      color: $dark-gray;\n    }\n  }\n}\n\n.search-input {\n  width: 100%;\n  padding-right: 30px; /* Adjust based on the size of the clear button */\n}\n\n.clear-button {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.people-viewport {\n  min-height: 50px;\n  max-height: 200px;\n  width: 100%;\n  border: none;\n  border-radius: 4px;\n  overflow: auto;\n  margin-top: 15px;\n  margin-left: 6px;\n  .cdk-virtual-scroll-spacer {\n    height: 100%!important;\n  }\n  .people-name-container {\n    gap: 12px;\n     .seperator {\n      margin: 0 6px;\n    }\n    .person-email {\n      @include note-text;\n      color: $dark-gray;\n    }\n  }\n  .no-results {\n    @include note-text;\n    color: $dark-gray;\n    font-style: italic;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n}\n\n.people-item {\n  @include small-text;\n  color: $black;\n  padding: 5px 10px;\n  border-bottom: 1px solid $light-gray;\n  margin-right: 6px;\n  cursor: pointer;\n  &:hover {\n    background-color: $light-gray;\n  }\n  &:last-of-type {\n    border-bottom: none;\n  }\n\n  .creation-date {\n    @include note-text;\n    color: $dark-gray;\n  }\n\n  strong {\n    @include small-text-bold;\n  }\n}\n\n.duo-name-container {\n  gap: 10px;\n  width: 100%;\n  margin-top: -35px;\n  padding-bottom: 5px;\n  &.duo-mode-mobile {\n    position: relative;\n    top: 10px;\n  }\n  .duo-name-individual {\n    @include small-text;\n    color: $white;\n  \n    &.pill {\n      border-radius: 26px;\n      background-color: $black;\n      padding: 3px 5px 3px 11px;\n      button.remove-button {\n        background-color: transparent;\n        cursor: pointer;\n        .remove-person {\n          width: 24px;\n          height: 24px;\n        }\n      }\n    }\n  }\n}\n\n\n\n#thematique {\n  margin: 12px auto;\n  padding: 9px 0px 12px;\n\n  p {\n    color: $white;\n    @include p-text;\n    padding: 0 0 18px;\n\n    &.section-collapsed {\n      @include small-text;\n\n      &:first-of-type {\n        padding-bottom: 0;\n      }\n    }\n  }\n\n\n  .question-category-container {\n    width: 100%;\n    padding-bottom: 18px;\n\n    .question-category {\n      position: relative;\n      margin: 6px 6px;\n\n      button {\n        color: $white;\n        @include p-text;\n        padding: 12px 24px;\n        background-color: $brand-green;\n        border-radius: 100px;\n        border: 1px solid $brand-green;\n        transition: all 0.3s ease;\n\n        &:hover {\n          color: $brand-green;\n          background-color: $white;\n        }\n      }\n\n      .back-button {\n        position: absolute;\n        left: -130px;\n        bottom: 0;\n        background-color: transparent;\n        border: none;\n\n        &:hover {\n          color: none;\n          background-color: transparent;\n        }\n\n        span {\n          color: $white;\n          @include small-text;\n          padding-left: 10px;\n        }\n      }\n    }\n  }\n\n  .question-puck {\n    color: $black;\n    @include small-text();\n    margin: 3px auto;\n    text-align: center;\n    padding: 10px 18px;\n    background-color: $white;\n    border-radius: 36px;\n    border: 1px solid $gray;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n\n    &:hover {\n      color: $black;\n      background-color: $accent-overlay;\n    }\n\n    &:last-of-type {\n      margin-bottom: 20px;\n    }\n  }\n\n  .arrow-show-hide {\n    position: relative;\n    height: 36px;\n    width: 36px;\n    border-radius: 50%;\n    text-align: center;\n    border: 1px solid $white;\n    background-color: transparent;\n    transition: transform 0.4s ease;\n\n    &:hover {\n      transform: translateY(5px);\n    }\n\n    .arrow {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    }\n  }\n}\n\n.reason-outer-box {\n  width: 100%;\n\n  .reasons-container {\n    width: 700px;\n    flex-wrap: wrap;\n  }\n\n  .reason-button {\n    color: $black;\n    @include small-text;\n    padding: 3px 12px;\n    background-color: $light-gray;\n    border-radius: 21px;\n    margin: 5px;\n    transition: all 0.3s ease;\n\n    &:hover,\n    &.selected-reason {\n      color: $white;\n      background-color: $charcoal;\n    }\n  }\n}\n\n.gradient-background {\n  position: relative;\n  background: linear-gradient(0deg, $white 19.26%, rgba(255, 255, 255, 0) 100%);\n  top: -53px;\n  height: 50px;\n  margin-bottom: -60px;\n  width: 98%;\n}\n\n.help-button-container {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n}\n\n.help-button {\n  position: relative;\n  background-color: transparent;\n  border: 1px solid $gray;\n  border-radius: 50%;\n  width: 36px;\n  height: 36px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n\n  .question-mark {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n\n  &:hover {\n    background: $accent-overlay;\n  }\n}\n\n.help-menu {\n  position: absolute;\n  width: 148px;\n  bottom: 50px;\n  right: 0;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.help-menu button {\n  color: $black;\n  display: block;\n  width: 100%;\n  @include note-text;\n  padding: 6px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  text-align: left;\n  transition: background-color 0.3s ease;\n\n  &:first-of-type {\n    border-bottom: 1px solid #F7F5F2;\n  }\n}\n\n.help-menu button:hover {\n  background-color: $accent-overlay;\n}\n\n#sherpa-notices {\n  padding-top: 111px;\n\n  h2 {\n    color: $white;\n    @include p-text-bold;\n    text-align: center;\n    &.mobile {\n      width: 350px;\n    }\n  }\n}\n\n.icon-jil {\n  padding-bottom: 24px;\n}\n\n.faq-header,\n.notice-header {\n  padding-bottom: 30px;\n}\n\n.faq-body,\n.notices-body {\n  background-color: $white;\n  border-radius: 26px;\n  position: relative;\n}\n\n.notices-body {\n  padding: 24px 24px 0px 24px;\n}\n\n.faq-body {\n  padding: 24px 24px 0px 24px;\n}\n\n.close-button {\n  background-color: transparent;\n  position: absolute;\n  right: 24px;\n  top: 24px;\n\n  img {\n    width: 10px;\n  }\n}\n\n// Terms and conditions\n.terms-and-conditions {\n\n  .faq-wrapper,\n  .terms-wrapper {\n    margin: 0 auto 30px;\n\n    h1 {\n      color: $black;\n      @include small-text-bold;\n      padding-bottom: 18px;\n    }\n\n    h3 {\n      color: $charcoal;\n      @include small-text-bold;\n    }\n\n    h4 {\n      color: $charcoal;\n      @include small-text-bold;\n    }\n\n    p {\n      color: $charcoal;\n      @include small-text;\n    }\n\n    .scrollable-section {\n      max-height: 350px;\n      overflow-y: auto;\n      padding-right: 18px;\n      &.terms-smal-viewport {\n        max-height: 410px;\n      }\n    }\n\n    .faq-scrollable-section {\n      max-height: 450px;\n      overflow-y: auto;\n      padding-right: 18px;\n    }\n  }\n\n  .terms-footer {\n    padding-bottom: 30px;\n  }\n\n  .acceptation-checkbox-wrapper {\n    cursor: pointer;\n    margin-bottom: 18px;\n\n    input {\n      margin-right: 12px;\n    }\n  }\n\n  .checkbox-container {\n    p {\n      color: $black;\n      @include small-text;\n      @include reset-padding-margin;\n    }\n  }\n\n  .btn-continue {\n    color: $white;\n    @include text-style(15px, 400, 20px, 'Arial');\n    padding: 6px 12px;\n    border-radius: 2px;\n    background-color: $bleu;\n    transition: background-color 0.3s ease;\n\n    &:hover {\n      background-color: $marin;\n    }\n\n    &:disabled {\n      color: $charcoal;\n      background-color: $gray;\n      cursor: not-allowed;\n    }\n  }\n}\n\n#faq-section {\n  position: relative;\n  top: 30%;\n  transform: translate(0%, -30%);\n  margin: 0 auto;\n}\n\n.faq-title {\n  color: $white;\n  @include text-style(65px, 700, 75px, 'Arial Black');\n  @include reset-padding-margin;\n}\n\n.top-close-button-container {\n  display: none;\n}\n\n#avertissement {\n  padding-bottom: 24px!important;\n}\n\n/*******************************************/\n/*                                         */\n/* S'applique au écrans avec une hauteur   */\n/* de 975px et moins                       */\n/*                                         */\n/*******************************************/\n\n@media (max-height: 925px) {\n  .sherpa-container {\n    justify-content: flex-start !important;\n    position: relative;\n    width: 100%;\n    padding: 40px 80px 80px;\n  }\n\n  .container-chat-window-visible {\n    padding: 10px 80px;\n  }\n\n  .txt.chat-window-visible {\n    @include logotype-text;\n  }\n\n  #sherpa-entete {\n    margin: 0 auto;\n  }\n\n  .entete {\n    padding: 0 9px 16px 9px;\n  }\n\n  #sherpa-chat .chat-window {\n    margin: 0 auto;\n    width: 100%;\n  }\n\n  .avertissement-question {\n    @include alternative-text;\n    font-size: 10px!important;\n    top: 44px;\n    margin-top: -36px;\n    margin-left: -13px;\n    margin-right: -13px;\n\n    p {\n      color: $black;\n      @include reset-padding-margin('bottom');\n      &:last-of-type {\n        position: relative;\n        top: 0px;\n      }\n    }\n  }\n\n  #sherpa-notices {\n    padding-top: 0;\n  }\n\n\n  #avertissement {\n    flex: 1 1 auto;\n    position: absolute;\n    bottom: 0;\n    &.mobile {\n      padding: 20px 15px 15px!important;\n      bottom: 75px;\n    }\n  }\n\n  .entete.entete-chat-window-visible {\n    @include reset-padding-margin;\n  }\n\n  .personality-button-container .radio-button {\n    position: absolute;\n    top: 60px;\n    left: 0;\n  }\n\n  #sherpa-chat .report-button-container {\n    margin: 0px 12px 0;\n    padding: 0px 12px 53px;\n  }\n\n  .question-sub-header {\n    padding: 8px 0 18px 0;\n\n    p {\n      font-family: 'Arial';\n      color: $white;\n      font-size: 15px;\n      font-weight: 700;\n      padding-bottom: 0;\n    }\n  }\n\n  .question-category-container {\n    padding-bottom: 20px;\n    width: 680px!important;\n  }\n\n  .chat-question-container {\n    padding: 0 0 10px 0;\n  }\n\n  .chat.answer {\n    max-height: 200px;\n  }\n\n  .chat.answer.reduced {\n    max-height: 10px;\n  }\n\n  .chat-messages {\n    margin: 12px auto 50px;\n}\n\n  #thematique {\n    width: 100%;\n    margin: 12px auto;\n    padding: 52px 0px 12px;\n    &.avertissement-none {\n      padding-top: 10px!important;\n    }\n\n    .question-category-container .question-category button {\n      @include small-text;\n      padding: 6px 12px;\n    }\n\n    .thematique-text-box {\n      padding: 0 0 9px;\n      margin: 0 0 9px;\n    }\n\n    .small-thematique-text-box {\n      padding: 0 0 6px;\n      margin: 0 0 1.5px;\n    }\n\n    .question-puck {\n      @include note-text;\n      padding: 6px 12px;\n    }\n\n    p {\n      @include small-text;\n      padding: 0 0 0;\n    }\n  }\n\n  .chat-input .input-wrapper {\n    width: 100%;\n  }\n\n  .chat-input input {\n    margin-right: 0;\n    width: 100%;\n  }\n\n  .gradient-background {\n    position: relative;\n    background: linear-gradient(0deg, $white 19.26%, rgba(255, 255, 255, 0) 100%);\n    top: -52px;\n    height: 40px;\n    width: 98%;\n  }\n\n  // .chat-messages {\n  //   margin: 0px auto!important;\n  // }\n\n  .chat-messages .chat-message-body {\n    max-height: 300px;\n  }\n\n  .chat-messages .chat-messages-bottom {\n    overflow-y: hidden;\n    overflow-x: hidden;\n    @include reset-padding-margin('top');\n  }\n\n  #thematique .question-category-container .question-category {\n    margin: 4.5px 4.5px;\n  }\n}\n\n/*******************************************/\n/*                                         */\n/* S'applique au écrans avec une Largeur   */\n/* de 1500px et moins                      */\n/*                                         */\n/*******************************************/\n@media (max-width: 1500px) {\n  .btn-report {\n    width: 195px;\n  }\n\n  .rightWrapper {\n    margin-right: unset;\n  }\n  .sherpa-container {\n    margin: 0 auto;\n  }\n\n  .sherpa-chat {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n\n  .chat-messages {\n    background-color: $white;\n    border-radius: 26px;\n    padding: 24px 24px 12px;\n    margin: 12px auto 50px;\n    // width: 767px;\n  }\n\n  .chat-input {\n    width: 100%;\n    padding: 10px 20px;\n  }\n\n  .chat-input .input-wrapper {\n    width: 100%;\n  }\n\n  .chat-input input {\n    margin-right: 0;\n    // width: 768px;\n  }\n}\n/*******************************************/\n/*                                         */\n/* S'applique au écrans avec une Largeur   */\n/* de 1440px et moins                      */\n/*                                         */\n/*******************************************/\n@media (max-width: 1440px) {\n\n  .rightWrapper {\n    margin-right: 0!important;\n  }\n  .sherpa-container {\n    width: 100%;\n    margin: 0 auto;\n    margin-left: none;\n  }\n\n  #sherpa-chat {\n    width: 100%;\n    padding-left: 12px;\n    padding-right: 12px;\n    margin: 0 auto;\n}\n\n  #thematique {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n\n  .chat-window {\n      flex: 1 1 auto;\n      width: 100%;\n      .chat-input {\n        padding: 10px 0px;\n        .input-wrapper {\n          width: 100%;\n          flex: 1 1 auto;\n          input {\n            width: 100%;\n          }\n        }\n      }\n  }\n}\n\n/*******************************************/\n/*                                         */\n/* S'applique au écrans avec une Largeur   */\n/* de 1235px et moins                      */\n/*                                         */\n/*******************************************/\n@media (max-width: 1235px) {\n  .sherpa-container {\n    position: relative;\n  }\n\n  .top-mobile-div {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n  }\n\n  .top-controls {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n  }\n\n  .top-close-button-container {\n    display: flex;\n    button.top-close-button {\n      background-color: transparent;\n    }\n  }\n\n  .sherpa-outer-column {\n    margin-left: 0;\n  }\n\n}\n\n/*******************************************/\n/*                                         */\n/* S'applique au écrans avec une Largeur   */\n/* comprise entre 374px et 820px           */\n/*                                         */\n/*******************************************/\n/* New media query for mobile devices between 315px and 500px */\n@media (min-width: 374px) and (max-width: 820px) {\n\n\n    html, body {\n      height: -webkit-fill-available;\n    }\n\n\n  .sherpa-outer-column {\n    position: relative;\n    z-index: 100000;\n  }\n\n  .top-mobile-div {\n    position: unset;\n    width: 100%;\n    display: flex;\n  }\n  .top-controls {\n    width: 100%;\n    padding: 0 15px;\n    position: unset;\n  }\n  .top-close-button {\n     background: transparent;\n    }\n\n    .messages-bottom .left-buttons .iconButton {\n      margin-left: 2px;\n    }\n\n  .icon {\n    &.thumbs_up {\n      &:hover {\n        transform: rotate(0deg) !important;\n      }\n    }\n\n    &.thumbs_down {\n      &:hover {\n        transform: rotate(0deg) !important;\n      }\n    }\n  }\n\n  .menu-container {\n    height: 41px;\n    background-color: $accent-overlay;\n    border-radius: 2px 2px 2px 2px;\n\n    .hamburger-container {\n      position: relative;\n      background-color: $brand-green;\n      padding: 10px 12px;\n      border-radius: 2px 0 0 2px;\n\n      .top-menu {\n        min-width: 215px;\n        position: absolute;\n        top: 50px;\n        left: 0;\n        border-radius: 2px;\n        background-color: $white;\n        box-shadow: 0px 4px 13.1px 0px rgba(0, 0, 0, 0.25);\n        z-index: 1000;\n\n        .inner-menu-label {\n          color: $dark-gray;\n          @include text-style(9px, 700, 18px, 'Arial');\n          text-transform: uppercase;\n          padding: 12px;\n          width: 100%;\n          border-bottom: 1px solid #F7F5F2;\n        }\n\n        .inner-menu-button {\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          width: 100%;\n          white-space: nowrap;\n          background-color: $white;\n          color: $black;\n          @include note-text;\n          padding: 12px 18px 6px;\n\n          &:last-of-type {\n            padding-bottom: 18px;\n          }\n        }\n      }\n    }\n\n    .label-container {\n      width: 100%;\n\n      .menu-label {\n        padding: 7px 17px;\n        color: $black;\n        text-align: center;\n        font-family: Arial;\n        font-size: 15px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 18px;\n      }\n    }\n\n  }\n\n  .line {\n    position: relative;\n    z-index: 1000;\n    width: 17px;\n    height: 3px;\n    background-color: #EDF2F5;\n    display: block;\n    margin: 3px auto;\n    transition: transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1),\n      opacity 0.5s cubic-bezier(0.25, 0.8, 0.25, 1),\n      width 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);\n  }\n\n  .hamburger.is-active {\n    transform: rotate(90deg);\n  }\n\n  .hamburger.is-active .line:nth-child(2) {\n    opacity: 0;\n    transition: opacity 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);\n  }\n\n  .hamburger .line:nth-child(2) {\n    transition-delay: 0.2s;\n  }\n\n  .hamburger.is-active .line:nth-child(1),\n  .hamburger.is-active .line:nth-child(3) {\n    width: 17px;\n    transform-origin: right;\n    transition: transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1),\n      width 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);\n  }\n\n  .hamburger.is-active .line:nth-child(1) {\n    transform: translateY(5px) rotate(-45deg);\n  }\n\n  .hamburger.is-active .line:nth-child(3) {\n    transform: translateY(-5px) rotate(45deg);\n  }\n\n\n\n  .rightWrapper {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n\n  .activate-sherpa-container[_ngcontent-ng-c3832421973] {\n    width: 90% !important;\n    margin: 15px auto !important;\n  }\n\n  .sherpa-outer-column {\n    min-width: unset !important;\n    margin-left: 0 !important;\n    min-height: 100vh;\n    height: 100%;\n    height: -webkit-fill-available;\n    background: linear-gradient(135deg, $brand-green 0%, $gray 100%);\n  }\n\n  .background-wrapper {\n    min-height: unset;\n    height: 100dvh;\n    background-image: none;\n\n    &:before {\n      display: none;\n    }\n  }\n\n\n  .sherpa-container {\n    justify-content: space-between !important;\n    width: 100%;\n    margin: 0 auto;\n    left: 0 !important;\n    padding: 20px 0 135px !important;\n    position: relative;\n    height: 100svh;\n    &.first-question-asked {\n      padding: 20px 0 75px !important;\n    }\n  }\n\n  .container-terms-faq {\n    justify-content: start !important\n  }\n\n  #faq-section {\n    top: 0;\n    transform: translate(0, 0);\n\n    .faq-body {\n      width: 95%;\n      margin: 0 auto;\n    }\n  }\n\n  #sherpa-notices {\n    @include reset-padding-margin('top');\n    width: 95%;\n  }\n\n  #sherpa-entete {\n    .sous-entete {\n      h2 {\n        text-align: center;\n        width: 280px;\n      }\n    }\n  }\n\n  .entete {\n    padding: 20px 10px;\n\n    &.entete-chat-window-visible {\n      padding: 5px 12px 9px;\n      margin: 0 auto !important;\n    }\n\n  }\n\n  .mobile-chat-window {\n    width: 100%;\n    padding: 0 12px;\n    display: flex;\n  }\n\n  .chat-messages {\n    flex: 1 1 auto;\n    overflow-y: auto;\n    margin: 12px auto;\n    &.duo-mode {\n      margin: 0 auto;\n      margin-bottom: 40px;\n    }\n  }\n\n  .chat-messages .chat-message-body {\n    max-height: unset;\n  }\n .chat-answer-container {\n    display: flex;\n  }\n  .chat.answer {\n    flex: 1 1 auto;\n    overflow-y: auto;\n    max-height: 190px;\n  }\n\n  .gradient-background {\n    top: -60px;\n    width: 97%;\n  }\n\n  .loading-indicator {\n    padding-bottom: 35px;\n  }\n\n  .chat.answer .text {\n    p {\n      &:last-of-type {\n        padding-bottom: 35px;\n      }\n    }\n  }\n\n  .arrow-forward {\n    transform: rotate(-90deg);\n  }\n\n  #carrousel {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    overflow-x: scroll;\n    scroll-snap-type: x mandatory;\n    -webkit-overflow-scrolling: touch;\n    padding: 20px 0;\n\n    .carousel {\n      display: flex;\n      align-items: flex-end;\n      gap: 16px;\n      padding: 0 20px;\n      width: 100%;\n\n      &::after {\n        content: '&nbsp;';\n        flex: 0 0 20px;\n        width: 20px;\n        color: transparent;\n        /* Adjust this value to match the padding */\n      }\n\n\n      .card {\n        background-color: rgba(87, 87, 87, 0.90);\n        color: $white;\n        flex: 0 0 80%;\n        width: 258px;\n        max-width: 258px;\n        height: fit-content;\n        padding: 6px 12px;\n        border-radius: 2px;\n        scroll-snap-align: center;\n        background: rgba(87, 87, 87, 0.90);\n        \n        p {\n          color: $white;\n          text-align: left;\n          @include note-text;\n          @include reset-padding-margin;\n        }\n      }\n    }\n\n    /* Hide scrollbar */\n    &::-webkit-scrollbar {\n      display: none;\n    }\n\n    -ms-overflow-style: none;\n    /* IE and Edge */\n    scrollbar-width: none;\n    /* Firefox */\n  }\n\n\n\n\n  #thematique {\n    display: none !important;\n  }\n\n  #avertissement {\n    height: 60px !important;\n    text-align: center;\n\n  }\n\n  .duo-content {\n    width: 95%;\n    position: fixed;\n    top: 10%;\n    &.expanded {\n      height: 400px;\n    }\n  }\n\n @media (max-height: 750px) {\n    .sherpa-container.keyboard-open{\n      // padding: 20px 0 !important;\n      #sherpa-entete {\n        display: none;\n      }\n  }\n  }\n  .people-viewport {\n    .people-name-container {\n      flex-direction: column;\n      justify-content: flex-start;\n      align-items: flex-start;\n      gap: 0!important;\n    }\n  }\n  \n  .separator {\n    display: none;\n  }\n}\n\n/*******************************************/\n/*                                         */\n/* S'applique au écrans avec une Largeur   */\n/* comprise entre 100px et 374px           */\n/*                                         */\n/*******************************************/\n@media (min-width: 100px) and (max-width: 374px) {\n  .rightWrapper {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n}\n\n.custom-tooltip {\n  width: 600px;\n}\n\n\n.feedback-input {\n  text-align: left;\n}\n\n/*******************************************/\n/*                                         */\n/* S'applique au écrans avec une hauteur   */\n/* de 799px et moins                       */\n/*                                         */\n/*******************************************/\n@media (max-height: 799px) {\n  .chat.answer {\n    flex: 1 1 auto;\n    overflow-y: auto;\n    max-height: 180px;\n  }\n}\n\n/*******************************************/\n/*                                         */\n/* S'applique au écrans avec une hauteur   */\n/* de 699px et moins                       */\n/*                                         */\n/*******************************************/\n@media (max-height: 699px) {\n  .chat.answer {\n    flex: 1 1 auto;\n    overflow-y: auto;\n    max-height: 120px;\n  }\n  .terms-wrapper .scrollable-section.terms-smal-viewport {\n    max-height: 210px !important;\n}\n.terms-and-conditions .faq-wrapper .faq-scrollable-section, .terms-and-conditions .terms-wrapper .faq-scrollable-section {\n  max-height: 370px;\n  overflow-y: auto;\n  padding-right: 18px;\n}\n\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
